/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Внутренняя ошибка',
      not_allowed: 'Действие не разрешено',
      access_denied: 'Доступ запрещен',
      validator_error: 'Ошибка проверки {details}',
      wrong_body: 'Wrong body',
      wrong_token: 'Неправильный токен',
      missing_token: 'Токен отсутствует',
      exclusive_lock: 'Исключительная блокировка',
      access_denied_acl: 'Доступ запрещён (ACL)',
      connection_timeout: 'Время соединения вышло',
      login_required: 'Требуется вход в систему',
      not_found: 'Не найдено',
      wrong_value: 'Неправильное значение',
      token_expired: 'Срок действия токена истек',
      service_not_available: 'Сервис недоступен',
      twofa_required: 'Требуется 2FA аутентификация ',
      missing_login_token: 'Требуется вход в систему',
    },
    account: {
      banned: 'Аккаунт заблокирован',
      wrong_login_or_password: 'Неправильный логин или пароль',
      wrong_login: 'Неправильный логин',
      wrong_password: 'Неправильный пароль',
      blocked: 'Аккаунт заблокирован',
      missing_email: 'Адрес электронной почты не присвоен',
      same_password_used: 'Этот пароль уже был использован',
      apikey_not_created: 'API ключ не создан',
      apikey_already_created: 'API ключ уже создан',
      twofa_not_created: '2FA не создан',
      twofa_already_created: '2FA уже создан',
      deletion_already_started: 'Удаление аккаунта уже началось',
      wrong_twofa: 'Неправильный код 2FA',
      external_withdraw_not_available: 'Внешний вывод не доступен',
      twofa_limit: 'Ограничение 2FA',
      kyc_wrong_step: 'KYC неверный шаг',
      not_exists: 'Не существует',
      kyc_required: 'Требуется KYC',
      action_not_allowed: 'Действие не разрешено',
      migration: 'Migration',
      wrong_password_pattern: 'Пароль должен содержать от 8 до 64 символов, включая как минимум одну прописную букву, строчную букву, одну цифру и специальный символ',
    },
    market: {
      not_enough_funds: 'Недостаточно средств',
      missing_steam_token: 'Ссылка на обмен в Steam отсутствует',
      missing_steam_id: 'Отсутствует Steam ID',
      wrong_item_status: 'Неправильный статус предмета',
      item_already_queued: 'Предмет уже поставлен в очередь',
      max_price_limit: 'Максимальный ценовой лимит',
      item_not_available: 'Предмет недоступен',
      steam_vac_ban: 'Блокировка системой VAC в Steam',
      steam_trade_ban: 'Блокировка в системе обмена Steam',
      steam_private_profile: 'Скрытый профиль в Steam',
      steam_private_inventory: 'Скрытый инвентарь в Steam',
      steam_tradehold: 'Удержание обмена в Steam',
      cannot_check_tradeban: 'Невозможно проверить запрет на обмен',
      cannot_check_tradehold: 'Невозможно проверить удержание обмена',
      wrong_steam_token: 'Неправильный токен Steam',
      no_items_found: 'Предметы не найдены',
      items_limit: 'Ограничение по количеству предметов',
      instant_sell_disabled: 'Мгновенная продажа отключена',
      plan_not_found: 'Plan not found',
      price_too_low: 'Слишком низкая цена',
      queue_full: 'Очередь на вывод предметов заполнена. Повторите попытку позже.',
    },
    steam: {
      wrong_tradelink: 'Неправильная ссылка на обмен',
      private_inventory: 'Скрытый инвентарь в Steam',
      cannot_check_tradeban: 'Мы не можем проверить запрет на обмен',
      cannot_check_tradehold: 'Мы не можем проверить удержание обмена',
      vac_ban: 'Блокировка системой VAC',
      trade_ban: 'Блокировка в системе обмена',
      private_profile: 'Скрытый профиль в Steam',
      tradehold: 'Удержание обмена',
      wrong_token: 'Неправильный токен',
      missing_token: 'Ссылка на обмен в Steam отсутствует',
      missing_steam_id: 'Отсутствует Steam ID',
      community_ban: 'Блокировка в сообществе Steam',
      economy_ban: 'Блокировка на торговой площадке',
      platform_offline: 'Платформа оффлайн',
      cannot_check_escrow: 'Невозможно проверить депонирование',
      escrow: 'Вы используете Steam Guard через электронную почту, но этого недостаточно для обмена с нашими ботами. Чтобы иметь возможность обмениваться с нашими ботами, Вам необходимо активировать Steam Guard на мобильном устройстве.',
      fresh_account: 'Сначала Вам необходимо настроить профиль в Steam',
    },
    mutex: {
      long_lock: 'Длительная блокировка, повторите попытку через {ttl} секунд',
      exclusive_lock: 'Исключительная блокировка',
    },
    api: {
      missing_apikey: 'API ключ отсутствует',
      missing_secret: 'API ключ отсутствует',
      wrong_ip_address: 'Неправильный IP-адрес',
      private_ip_address: 'Скрытый IP-адрес',
      wrong_apikey: 'Неправильный API ключ',
    },
    record: {
      item_not_found: 'Предмет не найден',
      item_not_owned: 'Item not owned',
      own_item: 'Собственный предмет',
      there_are_no_records: 'Нет записей для отображения',
      record_already_exists: 'Запись уже существует',
      record_not_exists: 'Запись не существует',
      already_exists: 'Уже существует',
      not_exists: 'Не существует',
      not_updated: 'Не обновлено',
      forbidden: 'Запрещено',
    },
    bot: {
      not_found: 'Бот не найден',
      not_available: 'Бот недоступен',
    },
    wallet: {
      cannot_transfer_money: 'Невозможно перевести деньги',
      amount_negative: 'Сумма отрицательная',
      amount_positive: 'Сумма положительная',
      card_scoring_too_low: 'Слишком низкий рейтинг карты',
      not_enough_balance: 'Недостаточно баланса',
      kyc_window_limit: 'Ограничение окна KYC',
      service_window_limit: 'Service window limit',
      amount_limit: 'Ограничение суммы',
      wrong_wallet_address: 'Неправильный адрес кошелька',
      card_not_found: 'Карта не найдена',
      cannot_process_transaction: 'Мы не можем обработать Вашу транзакцию',
      only_past_months_accepted: 'Принимаются только последние месяцы',
      only_visa_allowed: 'Разрешаются только карты VISA',
      you_cannot_complete_this_action: 'Вы не можете выполнить это действие, т.к. на Вашем счету недостаточно средств.',
      you_need_to_deposit_at_least_x: 'Для выполнения этого действия Вам необходимо внести как минимум {x}.',
    },
    gift_code: {
      not_found: 'Код не найден',
      already_used: 'Код уже использован',
      own_code: 'Это Ваш собственный код',
    },
    partner: {
      subaccount_not_enabled: 'Дополнительный аккаунт не активирован',
      link_account_first: 'Сначала привяжите аккаунт',
      account_already_linked: 'Аккаунт уже привязан',
      wrong_phrase: 'Неправильная фраза',
      cannot_link_yourself: 'Cannot link yourself',
      account_already_exists: 'Аккаунт уже существует',
    },
    payment: {
      card_scoring: 'Слишком низкий рейтинг карты',
      payment_issue: 'Проблема с оплатой',
    },
    auth: {
      failed_to_authenticate: 'Не удалось пройти аутентификацию',
      not_valid_identity: 'Неверное удостоверение личности',
      authentication_failed: 'Аутентификация не удалась',
    },
    social: {
      cannot_create_chat: 'Невозможно создать чат',
    },
    support: {
      wrong_status: 'Неправильный статус',
      ticket_limit: 'Ограничения по количеству и частоте подачи заявок',
    },
    ipn: {
      verification_issue: 'Проблема верификации',
    },
    affiliate: {
      same_code: 'Одинаковый код',
      code_taken: 'Данный код уже занят',
      not_activated: 'Не активирован',
      not_enough_balance: 'Недостаточо баланса',
    },
    bam: {
      bam_steam_015: 'Наши боты потеряли сеансы Steam. Пожалуйста, повторите попытку через несколько минут.',
    },
  },
  validator: {
    required: 'Это поле обязательно к заполнению.',
    string: 'Это поле должно представлять собой строку.',
    stringEmpty: 'Это поле не должно быть пустым.',
    stringMin: 'Длина этого поля должна составлять не менее {expected} символов.',
    stringMax: 'Длина этого поля должна составлять не более {expected} символов.',
    stringLength: 'Длина этого поля должна составлять {expected} символов.',
    stringPattern: 'Это поле не соответствует требуемому шаблону.',
    stringPatternLatin: 'Пожалуйста, используйте только латинские символы.',
    stringContains: 'Это поле должно содержать \'{expected}\' текст.',
    stringEnum: 'Это поле не соответствует ни одному из допустимых значений.',
    stringNumeric: 'Это поле должно быть числовой строкой.',
    stringAlpha: 'Это поле должно быть алфавитной строкой.',
    stringAlphanum: 'Это поле должно представлять собой алфавитно-цифровую строку.',
    stringAlphadash: 'Это поле должно быть строкой алфадаша.',
    stringHex: 'Это поле должно быть шестнадцатеричной строкой.',
    stringSingleLine: 'Это поле должно быть однострочной строкой.',
    stringBase64: 'Это поле должно представлять собой строку base64.',
    number: 'Это поле должно быть числом.',
    numberMin: 'Это поле должно быть больше или равно {expected}.',
    numberMax: 'Это поле должно быть меньше или равно {expected}.',
    numberEqual: 'Это поле должно быть равно {expected}.',
    numberNotEqual: 'Это поле не может быть равно {expected}.',
    numberInteger: 'Это поле должно быть целым числом.',
    numberPositive: 'Это поле должно быть положительным числом.',
    numberNegative: 'Это поле должно быть отрицательным числом.',
    array: 'Это поле должно быть массивом.',
    arrayEmpty: 'Это поле не должно быть пустым массивом.',
    arrayMin: 'Это поле должно содержать не менее {expected} предметов.',
    arrayMax: 'Это поле должно содержать меньше или равно {expected} предметов.',
    arrayLength: 'Это поле должно содержать {expected} предметы.',
    arrayContains: 'Это поле должно содержать {expected} предмет.',
    arrayUnique: 'The \'{actual}\' value does not unique the \'{expected}\' values.',
    arrayEnum: 'The \'{actual}\' value does not match any of the \'{expected}\' values.',
    tuple: 'Это поле должно быть массивом.',
    tupleEmpty: 'Это поле не должно быть пустым массивом.',
    tupleLength: 'Это поле должно содержать {expected} предметы.',
    boolean: 'Это поле должно быть логическое значением.',
    currency: 'Это поле должно иметь действительный формат валюты.',
    date: 'Это поле должно быть Датой.',
    dateMin: 'Это поле должно быть больше или равно {expected}.',
    dateMax: 'Это поле должно быть меньше или равно {expected}.',
    enumValue: 'Значение этого поля \'{expected}\' не соответствует ни одному из допустимых значений.',
    equalValue: 'Значение этого поля должно быть равно \'{expected}\'.',
    equalField: 'Значение этого поля должно быть равно \'{expected}\' значению поля.',
    forbidden: 'Это поле запрещено.',
    function: 'Это поле должно быть функцией.',
    email: 'В этом поле должен быть действительный адрес электронной почты.',
    emailEmpty: 'Это поле не должно быть пустым.',
    emailMin: 'Длина этого поля должна составлять не менее {expected} символов.',
    emailMax: 'Длина этого поля должна составлять не более {expected} символов.',
    luhn: 'This field must be a valid checksum luhn.',
    mac: 'В этом поле должен быть действительный MAC-адрес.',
    object: 'Это поле должно быть объектом.',
    objectStrict: 'Этот объект содержит запрещенные ключи: \'{actual}\'.',
    objectMinProps: 'Этот объект должен содержать как минимум {expected} свойств.',
    objectMaxProps: 'Этот объект должен содержать максимум {expected} свойств.',
    url: 'В этом поле должна быть действительная ссылка.',
    urlEmpty: 'Это поле не должно быть пустым.',
    uuid: 'Это поле не соответствует формату кода.',
    uuidVersion: 'В этом поле должен быть представлен правильный вариант UUID.',
    classInstanceOf: 'Это поле должно быть экземпляром класса \'{expected}\'.',
    objectID: 'Это поле должно быть действительным ObjectID',
    record: 'Это поле должно быть объектом.',
  },
  body: {
    language: 'Язык',
    currency: 'Валюта',
    currency_warning: 'Все операции производятся в долларах США (далее USD), валюты, отличные от USD, конвертируются из USD и изменяют только внешний вид страницы. Изменение курса валют может увеличить или уменьшить Ваш баланс.',
    choose_game: 'Выберите игру',
    slider: {
      title_1: 'Обновите свой стиль,',
      title_2: 'Доминируйте в игре',
      content_1: 'Откройте для себя лучшую коллекцию скинов',
      content_2: 'Чтобы повысить Ваши игровые впечатления.',
      tile_1: 'Увеличьте Ваш игровой опыт',
      tile_2: 'Получите лучшее соотношение цены и качества',
      tile_3: 'Наслаждайтесь безопасной и гладкой торговлей',
    },
    footer_description: 'В компании BitSkins мы стремимся предоставить игрокам безопасную и надёжную платформу для покупки и продажи предметов из таких популярных игр, как CS:GO, Dota 2, Rust и TF2. С момента нашего запуска в 2015 году мы успешно обслужили миллионы довольных клиентов, и наше обязательство по безопасности и защите остаётся сильнее, чем когда-либо.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Работает на технологии Steam. Не связан с Valve Corp.',
    footer_email_support: 'Если Вам нужна поддержка',
    footer_email_security: 'Если Вы хотите сообщить об ошибках',
    footer_email_partnership: 'Если Вы хотите сотрудничать',
    market: 'Магазин',
    cart: 'Корзина',
    cart_empty: 'Ваша корзина пуста',
    clear_cart: 'Очистить корзину',
    checkout: 'Оформление заказа',
    in_the_cart: 'в корзине',
    total: 'Всего',
    go_to_market: 'Перейти в магазин',
    trustpilot_alt: 'Trustpilot с {stars} звездами и {reviews} отзывами',
    reload_website: 'Перезагрузите сайт!',
    app_error: 'Ошибка приложения: {error}',
    latest_articles: 'Последние статьи',
    steam_login: 'Вход в Steam',
  },
  maintenance: {
    we_will_be_back_soon: 'Мы вернемся в ближайшее время',
    we_are_down_for_maintenance: 'Мы закрыты на техническое обслуживание, но в ближайшее время мы будем снова онлайн.',
    sorry_for_the_inconvenience: 'Приносим извинения за неудобства и до скорой встречи!',
  },
  account: {
    email: {
      required: 'Требуется адрес электронной почты',
      required_for_this_payment_method: 'Вы не можете использовать этот способ оплаты, поскольку Вы не указали свой адрес электронной почты.',
      you_can_start_now: 'Вы можете начать процесс установки прямо сейчас.',
      setup: 'Настройка электронной почты',
    },
    add_funds: 'Добавить средства',
    my_store: 'Мой магазин',
    selling: 'Продажа',
    transactions: 'Транзакции',
    settings: 'Настройки',
    steam_settings: {
      open_settings: 'Открыть настройки',
      open_steam_settings: 'Открыть Steam профиль',
      what_is_steam_guard: 'Что такое Steam Guard?',
      inventory_status: 'Состояние инвентаря',
      profile_status: 'Состояние профиля',
      change_trade_link: 'Изменить ссылку на обмен',
    },
    logout: 'Выход из системы',
    inventory: 'Инвентарь',
    banned: {
      you_are_banned: 'Вы <span class="text-cr">заблокированы</span>.',
      your_account_has_been_banned: 'Ваша учётная запись была заблокирована за нарушение наших',
      your_account_has_been_blocked: 'Ваша учётная запись была заблокирована за нарушение наших',
      if_you_believe: 'Если Вы считаете, что это была ошибка, Вы можете связаться с нами по адресу <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: 'Условия использования',
    },
    account_blocked: 'Учетная запись <span class="text-cr">заблокирована</span>.',
    api_access: 'API доступ',
  },
  balance: {
    wallet: 'Кошелек',
    withdraw: 'Вывести',
    withdraw_to: 'Вывести в',
    withdraw_again: 'Вывести снова',
    withdrawable: 'Итого к выводу',
    total: 'Всего',
    balance: 'Баланс',
    deposits_and_sales: 'Пополнения и продажи',
    proceeds_from_sales: 'Доход от продаж',
    deposit: 'Пополнить баланс',
    locked: 'Заблокированo',
    funds_locked: 'Средства, заблокированные в транзакциях',
    pending_withdrawals: 'Ожидается вывод средств',
    thank_you_for_your_payment: 'Спасибо за оплату',
    your_money_will_arrive_soon: 'Ваши средства поступят в ближайшее время',
    your_payment_is_still_processing: 'Ваш платеж все еще обрабатывается, но средства должны появиться на Вашем счету в ближайшее время.',
    in_case_you_do_not_receive: 'Если Вы не получили свои средства в течение 15 минут, обратитесь в нашу службу поддержки.',
    payment_pending: 'Платеж <span class="text-cbs">ожидается</span>',
    payment_failed: 'Платеж<span class="text-cr">не удался</span>',
    payment_canceled: 'Платеж <span class="text-cg">отменен</span>',
    payment_has_been_cancelled: 'Платеж был отменен согласно запросу',
    unfortunately_we_were_unable: 'К сожалению, нам не удалось обработать Ваш платеж.',
    please_try_again: 'Пожалуйста, попробуйте ещё раз',
    if_the_problem_persists: 'Если проблема не устранена, обратитесь в нашу службу поддержки. Вы также можете попробовать использовать другой способ оплаты.',
    back_to_wallet: 'Назад к кошельку',
    total_description: 'Средства, полученные от ваших пополнений и продаж.',
    withdrawable_description: 'Доход от продаж. Эти средства можно вывести или потратить на покупку предметов.',
    locked_description: 'Временно заблокированные средства, которые нельзя потратить или вывести. Причина блокировки средств связана с существующими заказами на покупку, покупкой предметов и т.д.',
    deposit_with_cryptocurrencies: 'Пополнение с помощью <span class="text-cp">криптовалют</span>',
    deposit_with_standard_payment_methods: 'Пополнение с помощью <span class="text-cp">стандартных методов оплаты</span>',
    withdraw_with_cryptocurrencies: 'Вывод средств с помощью <span class="text-cp">криптовалют</span>',
    withdraw_with_standard_payment_methods: 'Вывод средств с помощью <span class="text-cp">стандартных методов оплаты</span>',
    your_amount: 'Ваша сумма',
    your_limit: 'Ваше ограничение',
    your_limits: 'Ваши ограничения',
    increase_your_limits: 'Увеличьте свои ограничения',
    payment_not_available_in_the_following_countries: 'Этот способ оплаты недоступен в следующих странах:',
    the_price_is_updated_every_60_seconds: 'Цена обновляется каждые 60 секунд и представляет собой среднюю цену, собранную с нескольких бирж.',
    rate_includes_x_fee: 'В ставку включена комиссия в размере {x}%.',
  },
  not_found: {
    title: 'Страница не найдена',
    message: 'Похоже, что Вы заблудились. Вы можете найти <br> скины своей мечты на странице магазина.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Добро пожаловать</span> в BitSkins.',
    sign_in: 'Вход',
    sign_up: 'Регистрация',
    rules_text: 'Я подтверждаю, что мне 18 лет или больше, и соглашаюсь с',
    sign_in_with_steam: 'Войти с помощью Steam',
    sign_up_with_steam: 'Регистрация с помощью Steam',
    email: 'Электронная почта',
    password: 'Пароль',
    already_have_an_account: 'У Вас уже есть аккаунт? Нажмите',
    to_login: 'войти',
    to_login_via_email: 'войти через электронную почту',
    login_via_email: 'Вход через электронную почту',
    log_in_using_your_email: 'Войдите, используя свой адрес электронной почты и пароль.',
    forgot_password: 'Забыли пароль?',
    login_via_steam: 'ВХОД В СИСТЕМУ ЧЕРЕЗ STEAM',
    register_first: 'Для начала Вам нужно зарегистрироваться',
    passwords_not_migrated: 'К сожалению, во время недавнего обновления мы не смогли перенести Ваш пароль, поэтому Вам придется его сбросить.',
  },
  common: {
    monthly: 'ежемесячно',
    x_to_y: '{x} к {y}',
    minimum_x: 'Минимум {x}',
    maximum_x: 'Максимум {x}',
    click: 'Нажмите',
    claim: 'Получить',
    or: 'или',
    and: 'и',
    confirm: 'Подтвердите',
    continue: 'Продолжить',
    cancel: 'Отмена',
    enable: 'Включить',
    enabled: 'включен',
    disable: 'Отключить',
    disabled: 'отключено',
    download: 'Скачать',
    twofa: 'Двухфакторная аутентификация',
    terms_of_use: 'Условия использования',
    privacy_policy: 'Политика конфиденциальности',
    cookie_policy: 'Политика использования файлов cookie',
    about_us: 'О нас',
    changelog: 'Список изменений',
    faq: 'Часто задаваемые вопросы',
    support: 'Служба поддержки',
    affiliate: 'Партнерство',
    blog: 'Блог',
    careers: 'Карьера',
    api: 'API',
    service_status: 'Статус обслуживания',
    loading: 'Загрузка...',
    buy_skins: 'Купить скины',
    sell_skins: 'Продать скины',
    popular: 'Популярные',
    skin_categories: 'Категории скинов',
    payments: 'Платежные системы',
    about_bitskins: 'О компании BitSkins',
    social_media: 'Социальные сети',
    follow_us: 'Следуйте за нами и присоединяйтесь к нашему сообществу!',
    enter_your_email: 'Введите Ваш адрес электронной почты',
    phone_number: 'Номер телефона',
    verify: 'Проверить',
    add: 'Добавить',
    update: 'Обновить',
    check_spam_folder: 'Если Вы не можете найти письмо в Вашем почтовом ящике, проверьте папку "Спам".',
    here: 'здесь',
    edit: 'редактировать',
    save: 'сохранить',
    copy: 'скопировать',
    back: 'Назад',
    back_to_login: 'Вернуться на страницу входа',
    clear: 'Очистить',
    quantity: 'Количество',
    name: 'Имя',
    bot_name: 'Имя бота',
    steam: 'Steam',
    steam_id: 'Steam ID',
    steam_group: 'группа в Steam',
    browser: 'Браузер',
    on: 'Включить',
    off: 'Выключить',
    hidden: 'Скрытый',
    empty: 'Пустой',
    expires_in: 'Срок действия истекает через ',
    member_since: 'Участник с',
    close: 'Закрыть',
    paint_seed_value: 'Узор (Paint seed): {value}',
    error: 'Ошибка',
    retry: 'Повторить попытку',
    no_options_available: 'Нет доступных вариантов',
    search: 'Поиск',
    any: 'Любой',
    min: 'Минимум',
    max: 'Максимум',
    no_limit: 'Без ограничений',
    scroll_left: 'Прокрутка влево',
    scroll_right: 'Прокрутка вправо',
    load: 'Загрузка',
    delete: 'Удалить',
    remove: 'Удалить',
    all: 'Все',
    game: 'Игра',
    reset: 'Сброс',
    in: 'в',
    optional: '(необязательно)',
    default: 'По умолчанию',
    filter: 'Фильтр',
    up_to: 'До',
    similar: 'Похожие',
    important: 'Важно',
    step: 'Шаг',
    share_link: 'Поделиться ссылкой',
    zoom: 'Масштабировать',
    found: 'Найдено',
    try_again: 'Попробуйте еще раз',
    of: 'из',
    timer: 'Таймер',
    add_new: 'Добавить новый',
    and_more: 'И БОЛЕЕ',
    check_status: 'Проверить состояние',
    resend_link: 'Переслать ссылку',
    back_to_home: 'Вернуться на главную страницу',
    data_visible_only_to_logged_in_users: 'Эти данные видны только авторизованным пользователям',
    login: 'Логин',
    level: 'Уровень',
    twofa_code: 'Код 2FA',
    id: 'ID',
    position: 'Позиция',
    amount: 'Сумма',
    progressive_sum: 'Progressive sum',
    date: 'Дата',
    active: 'Активный',
    yes: 'Да',
    no: 'Нет',
  },
  notifications: {
    change: 'Изменить',
    setup: 'Настроить',
    disconnect: 'Отключить',
    connect: 'Подключить',
    notifications: 'Уведомления',
    notifications_center: 'Центр уведомлений',
    clear_all: 'Очистить все уведомления',
    notifications_channels: 'Каналы уведомлений',
    connected: 'Подключено',
    all_notifications: 'Все уведомления',
    sound: 'Звук',
    volume_mute: 'Отключение звука',
    volume_full: 'Полная громкость',
    all_sounds: 'Все звуки:',
    off: 'Выключить',
    on: 'Включить',
    steam_issues_title: 'Проблемы со Steam',
    steam_issues_content: 'В Steam наблюдаются проблемы, которые могут повлиять на сделки, в результате чего они не будут обрабатываться или создаваться.',
    name: {
      account_new_login: 'Новый вход в аккаунт',
      inventory_sold: 'Предмет продан',
      inventory_buyorder: 'Инвентарь заказ на покупку',
      wallet_deposit_done: 'Пополнение кошелька завершено',
      support_new_reply: 'Новый ответ от службы поддержки',
      support_ticket_closed: 'Заявка в службу поддержки закрыта',
      inventory_bargain_received: 'Получено предложение на торг',
    },
  },
  market: {
    non_scraped_only: 'Только не поцарапанные',
    set_price: 'Установить цену',
    game_not_found: 'Игра не найдена',
    game_not_available: 'Игра в настоящее время недоступна',
    any_stickers: 'Любые наклейки',
    item_removed_from_sale: 'Предмет снят с продажи',
    price_updated: 'Цена обновлена',
    item_withdrawn: 'Этот предмет был получен',
    go_to_withdrawn: 'Перейти к полученным предметам',
    item_issue: 'У нас возникла проблема с этим предметом',
    item_in_deposit_queue: 'Этот предмет находится в очереди на пополнение',
    item_in_withdraw_queue: 'Этот предмет находится в очереди на вывод',
    go_to_queued: 'Перейти к предметам в очереди',
    item_in_bitskins_inventory: 'Этот предмет находится в Вашем инвентаре BitSkins',
    go_to_inventory: 'Перейти в инвентарь',
    go_to_issue: 'Перейти к проблемам',
    maximum_price: 'Максимальная цена',
    minimum_price: 'Минимальная цена',
    average_price: 'Средняя цена',
    amount_sold: 'Сумма продажи',
    withdrawal_batch_info: 'Пожалуйста, имейте в виду, что мы отправляем предметы партиями каждые несколько минут.',
    queued: 'В очереди',
    queued_description: 'Здесь вы можете найти предметы, которые стоят в очереди на вывод или депозит.',
    withdrawn: 'Получено',
    withdrawn_description: 'Здесь вы можете найти предметы, которые были выведены.',
    issues: 'Проблемы',
    issues_description: 'Здесь вы можете найти предметы, с которыми у нас возникли проблемы. В настоящее время мы работаем над решением этих проблем.',
    max_items_selected: 'Вы не можете выбрать более {limit} предметов',
    item_status: 'Состояние предмета',
    search_for_stickers: 'Поиск наклеек',
    this_item: '(этот предмет)',
    no_items_found: {
      no_items_found: 'Предметы не найдены',
      no_items_found_span: 'Предметы <span>не найдены</span>',
      we_could_not_find_any_offers: 'Мы не смогли найти никаких предложений',
      for: ' для',
      this_can_be_due_to_applied_filters: 'Это может быть связано с примененными фильтрами. Вы можете очистить все фильтры, нажав на кнопку ниже',
    },
    only_tradable_items: 'Только обмениваемые предметы',
    not_accepting: 'Не принимается',
    sell: 'Продать',
    skin: 'Скин',
    items: 'предметы',
    items_v2: 'предметы',
    buy_orders: 'Заказы на покупку',
    search_for: 'Поиск {game} предметов',
    search_for_items: 'Поиск предметов',
    reload: 'Перезагрузка',
    item_name: 'Название предмета',
    enter_item_name: 'Введите название предмета',
    price: 'Цена',
    reset: 'Сброс',
    all_items: 'Все предметы',
    sort: 'Сортировка',
    add_sort: 'Добавить сортировку',
    steam_price: 'Цена в Steam',
    reference_price: 'Справочная цена',
    steam_inventory: 'Инвентарь в Steam',
    your_steam_inventory: 'Ваш инвентарь в Steam',
    bitskins_inventory: 'Инвентарь в BitSkins',
    your_bs_inventory: 'Ваш инвентарь в BitSkins {extra}',
    refresh: 'Обновить',
    learn_how_to_sell: 'Узнайте, как продавать',
    select_1_by_1: 'Выберите 1 к 1',
    select_all: 'Выбрать все',
    selected_items: 'Выбранные предметы',
    items_amount: '{count} предметов',
    offers: 'предложения',
    favorites: 'Избранное',
    last: 'Последние',
    viewed: 'просмотренные',
    same_price: {
      same_price_for: 'Та же цена для',
      all_items: 'всех предметов',
    },
    save_all: 'Сохранить все',
    trade_hold: {
      name: 'Удержание обмена',
      between: 'Заблокировано на период от {min} до {max} дней',
      less: 'Заблокировано менее чем на {value} дней',
      any: 'Любое удержание обмена',
      none: 'Без удержания',
      withdrawable_in_days_hours: 'Вывод возможен через {days} дней, {hours} часов',
      withdrawable_in_hours_minutes: 'Вывод возможен через {hours} часов, {minutes} минут',
      tradable: 'Можно обменять',
    },
    filter: {
      status: 'Состояние',
      date_from: 'Дата от',
      date_to: 'Дата до',
      amount_from: 'Сумма от',
      amount_to: 'Сумма до',
      price_from: 'Цена от',
      price_to: 'Цена до',
      service: 'Обслуживание',
      item: 'Предмет',
      game: 'Игра',
      type: 'Тип',
      quality: 'Редкость',
      exterior: 'Внешний вид',
      category: 'Категория',
      collection: 'Коллекция',
      color: 'Цвет',
      family: 'Семейство скинов',
      phase: 'Фаза',
      rarity: 'Редкость',
      grade: 'Класс',
      killstreak: 'Killstreak',
      effect: 'Эффект',
      hero: 'Герой',
      nametag: 'Именной ярлык',
      hightier: 'Высокий уровень',
      stickers: 'Наклейки',
      slot: 'Slot {value}',
      paint_seed: 'Узор (Paint seed)',
      paint_index: 'Paint index',
      sticker_counter: 'Количество наклеек',
      float_value: 'Степень износа',
      active: '{value} активно',
      by_slot_position: 'По расположению слотов',
      filter_name: 'Фильтры по имени',
      you_can_have: 'У вас могут быть',
      filters_saved: 'сохранены фильтры.',
      choose_stickers: 'Выбрать наклейки',
      no_stickers_found: 'Наклейки не найдены',
      basic_filters: 'Основные фильтры',
      advanced_filters: 'Другие фильтры',
      clear_all_filters: 'Очистить все фильтры',
      save_filters: 'Сохранить фильтры',
      my_filters: 'Мои фильтры',
      filters_are_not_available_on_this_page: 'Фильтры недоступны на этой странице',
    },
    loading_item: 'Загрузка предмета',
    bestseller: 'Самый популярный',
    this_is_your_item: 'Это Ваш предмет',
    action: {
      screenshot: 'Скриншот',
      inspect: 'Посмотреть в игре',
      view_at_steam: 'Посмотреть в Steam',
      check_on_steam_market: 'Проверить на Steam',
      share: 'Поделиться',
      sell_instantly: 'Продать мгновенно',
      buy: 'Купить',
      remove_from_sale: 'Снять с продажи',
      check_on_market: 'Проверить в магазине',
      item_page: 'Страница предмета',
      bulk_buy: 'Купить оптом',
      add_to_favorites: 'Добавить в избранное',
      remove_from_favorites: 'Удалить из избранного',
      buy_now: 'Купить сейчас',
      bump: 'Продвигать',
      sticker: 'Предметы с такими наклейками',
    },
    bump_minimum: 'Продвижение доступно только для предметов стоимостью более {amount}.',
    your_price: 'Ваша цена',
    cart: {
      add_to_cart: 'Добавить в корзину',
      remove_from_cart: 'Удалить из корзины',
      add_stickers_to_cart: 'Добавить наклейки в корзину',
      remove: 'Удалить',
      in_cart: 'В корзину',
    },
    details: 'Подробности',
    tags: 'Метки',
    do_you_want_rename: 'Вы хотите переименовать свой предмет?',
    currently_not_available: 'В настоящее время недоступно',
    nametag: 'Именной ярлык',
    sales: 'Продажи',
    private_offer: 'Частное предложение',
    private_offers: 'Частные предложения',
    private_offers_description: 'У Вас есть частные предложения: {counter}. Вы можете найти их',
    public_offer: 'Публичное предложение',
    offer_visible_only_to_people_with_link: 'Это предложение видно только людям, имеющим на него ссылку',
    checkout: {
      if_any: 'Если какие-либо предметы в Вашей корзине больше не доступны, они не будут добавлены в Ваш заказ.',
      remove_all_items: 'Удалить все предметы',
      order_summary: 'Итог заказа',
      you_will_save: 'Вы сэкономите',
      i_have_read: 'Я прочитал и согласен с Условиями обслуживания и Политикой конфиденциальности и понимаю, что все покупки являются окончательными и возврату не подлежат.',
      confirm_checkout: 'Подтвердить оформление заказа',
      you_need_to_deposit_at_least_x: 'Вам необходимо пополнить счет на сумму не менее {amount}, чтобы приобрести предметы в корзине.',
      you_cannot_complete: 'Вы не можете выполнить заказ, поскольку на Вашем счету недостаточно средств. Вам необходимо пополнить счет на сумму не менее {amount}, чтобы приобрести предметы в корзине.',
      these_items_will_be_removed: 'Эти предметы будут удалены из списка после оформления заказа.',
      this_item_will_not_be_included: 'Этот предмет не будет включен в Ваш заказ',
      need_tos_accept: 'Вам необходимо согласиться с Условиями использования и Политикой конфиденциальности',
      no_items_selected: 'Не выбрано ни одного предмета',
    },
    deposit_status: {
      available: 'Доступно',
      missing: 'Отсутствует',
      not_accepting: 'Не принимается',
      wrong_price: 'Неправильная цена',
      already_queue: 'Уже в очереди',
      locked: 'Заблокированные',
    },
    withdraw_progress: {
      status: 'Статус вывода',
      selected: 'Выбрано',
      waiting: 'Ожидание',
      in_queue: 'В очереди',
      trade_link: 'Сыллка на обмен',
      done: 'Готово',
      error: 'Ошибка',
      failed: 'Не удалось',
      pending: 'В ожидании',
    },
    trade_state: {
      Invalid: 'Недействительно',
      Active: 'Активно',
      Accepted: 'Принято',
      Countered: 'Встречное предложение',
      Expired: 'Срок действия истек',
      Canceled: 'Отменено',
      Declined: 'Отказано',
      InvalidItems: 'Недопустимые предметы',
      CreatedNeedsConfirmation: 'Создано, требует подтверждения',
      CanceledBySecondFactor: 'Отменено вторым фактором',
      InEscrow: 'на хранении',
    },
    trade_type: {
      deposit: 'Пополнение',
      withdraw: 'Вывести',
      bidirectional: 'Двунаправленный',
    },
    inventory: {
      history: 'История',
      active_trades: 'Активные обмены',
      loading_your_inventory: 'Загрузка Вашего инвентаря',
      lower_sale_fee: 'Комиссия за продажу снижена на {value}%',
      group_diff_price: 'Не все предметы в группе имеют одинаковую цену',
      group_diff_delist: 'Не все предметы в группе помечены для удаления из списка.',
      delist: 'Удалить из списка',
      this_may_take_a_while: 'Это может занять некоторое время',
      relist_items: 'Разместить предметы заново',
      cancel_relisting: 'Отменить повторное размещение',
      cancel_withdrawal: 'Отмена вывода',
      withdraw_items: 'Вывести предметы',
      cancel_editing: 'Отмена редактирования',
      edit_items: 'Редактирование предметов',
      sell_items: 'Продать предметы',
      steam_offers: 'Предложения Steam',
      clear_withdraw_items: 'Очистить предметы',
      loading_inventory: 'Загрузка инвентаря',
      update_x_items: 'Обновить {amount} предметов',
      delist_x_items: 'Удалить из списка {amount} предметов',
    },
    message: {
      failed_to_create_trade_offer: 'Не удалось создать предложение обмена.',
      offer: 'Предложение {hash}',
      offer_failed: 'Прдложение не удалось (with status {state})',
      offer_confirmed: 'Ваше предложение подтверждено, Вы успешно выставили свои предметы на продажу.',
      offer_sent: 'Ваше предложение обмена было отправлено',
      open_trade: 'Открыть предложение обмена',
      withdraw: 'Вывод предложения {hash}',
      withdraw_confirmed: 'Ваш вывод был принят',
      offer_preparing: 'Ваш обмен находится в стадии подготовки. Мы вышлем вам предложение в ближайшее время',
      offer_active: 'Ваш обмен готов. Принять здесь',
      offer_needs_confirmation: 'Подтвердите обмен в мобильном приложении',
    },
    deposit_type: {
      public: 'Публичный',
      public_description: 'Ваши предметы будут видны всем пользователям BitSkins. Это самый популярный вариант продажи.',
      private: 'Частный',
      private_description: 'Ваши товары будут видны только тем людям, у которых есть на них ссылка. Частная продажа на 50% дешевле стандартной.',
      instant_sell: 'Мгновенная продажа',
      instant_description: 'После отправки предметов нашему боту, деньги сразу же поступят на Ваш счет.',
    },
    click_to_open: 'Нажмите, чтобы открыть ссылку в новой вкладке',
    no_active_trades: 'Нет активных предложений для обмена',
    go_to_all_trades: 'Перейдите ко всем обменам',
    update_trade_link: 'Обновить ссылку на обмен',
    withdraw: 'Вывести',
    lowest_price: 'Самая низкая цена:',
    no_filters_available: 'Нет доступных фильтров',
    select_a_hero: 'Выбрать героя:',
    view_all_items: 'Посмотреть все предметы',
    stattrak: 'StatTrak™',
    item_not_available: 'Этот предмет больше не доступен',
    out_of_stock: 'Нет в наличии',
    find_similar_item: 'Найти похожий предмет',
    find_similar_items: 'Найти похожие предметы',
    sell_for: 'Продать за',
    recommended: 'Рекомендуемые',
    price_discounted: 'Цена со скидкой',
    price_average: 'Средняя цена (рекомендуемая)',
    price_expensive: 'Высокая цена',
    sticker: 'наклейка',
    more: 'Больше',
    recent: 'Последние',
    item_not_found: 'Предмет не найден',
    for: 'для',
    you_will_pay: 'Вы заплатите',
    fade: 'Градиент: {value}%',
    see_all_items: 'Посмотреть все {amount} предметы',
    it_my_take_a_while: 'Это может занять некоторое время',
    no_transactions_found: 'Не найдено ни одной транзакции',
    item: 'Предмет',
    edit: 'Редактировать',
    add_items_to_edit: 'Добавить предметы для редактирования',
    add_items_to_delist: 'Добавить предметы для удаления из списка',
    add_items_to_sale: 'Добавить предметы на продажу',
    add_items_to_withdraw: 'Добавить предметы для вывода',
    group_by_name: 'Группировать по имени',
    select_items_from_your_inventory: 'Выберите предметы из Вашего инвентаря',
    earnings: 'Доходы',
    total_fee: 'Общая сумма комиссии',
    total_amount: 'Общая сумма',
    confirm_purchase: 'Подтвердите <span class="text-cp">покупку</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">Благодарим Вас</span> за то, что делaете покупки у нас!',
    you_have_purchased_x_items_for: 'Вы приобрели <span class="text-cp">{x}</span> предметов за',
    you_have_purchased_x_for: 'Вы приобрели <span class="text-cp">{x}</span> за',
    total: 'Всего',
    you_saved: 'Ты сэкэномил',
    see_your_inventory: 'Посмотрите свой инвентарь',
    you_bought: 'Вы купили',
    order_details: 'Детали заказа',
    items_not_available: 'К сожалению, некоторые предметы из Вашей корзины стали недоступны, поэтому Вы не смоли их купить. Ниже Вы можете найти список этих предметов.',
    total_price: 'Общая цена',
    withdraw_all_items: 'Вывести все предметы',
    private_listing: 'Частное размещение {extra}',
    public_listing: 'Публичное размещение {extra}',
    instant_sale_price: 'Цена мгновенной продажи',
    not_accepted: 'Не принято',
    not_available: 'Недоступно',
    no_sales_data: 'Нет данных о продажах',
    create_buy_order: 'Создать заказ на покупку',
    active_buy_orders: 'Ваши активные заказы на покупку',
    buy_orders_history: 'История заказов на покупку',
    market_buy_orders: 'Заказы на покупку в магазине',
    recent_sales: 'Последние продажи',
    selling_price: 'Цена продажи',
    sales_chart: 'График продаж',
    sales_history_will_be_available_soon: 'История продаж BitSkins и Steam будет доступна в ближайшее время',
    souvenir: 'Сувенир',
    under: '{amount} и ниже',
    above: '{amount} и выше',
    amount_to_amount: 'от {amount1} до {amount2}',
    discount: 'Скидка',
    value_off_or_more: 'Скидка {value}% или более',
    removed_items: 'Удаленные предметы',
    restore_all_items: 'Восстановить все предметы',
    add_x_items_to_edit: 'Добавить {amount} предметов для редактирования',
    add_x_items_to_sale: 'Добавить {amount} предметов для продажи',
    add_x_items_to_withdraw: 'Добавить {amount} предметов для вывода',
    sell_x_items: 'Продать {amount} предметов',
    withdraw_x_items: 'Вывести {amount} предметов',
    first_you_need_to_select_an_item: 'Для начала Вам необходимо выбрать предмет.',
    cheapest_price_on_bitskins: 'Самая дешевая цена на BitSkins:',
    final_price: 'Окончательная цена:',
    check_quantity: 'Проверить количество',
    cancel_selected_orders: 'Отменить выделенные заказы',
    cancel_all_orders: 'Отменить все заказы',
    community_rating: 'Рейтинг сообщества:',
    rating: 'Рейтинг',
    votes: 'голоса',
    open_image: 'Открыть изображение',
    cheaper_than_steam_by_x: 'Дешевле, чем в Steam на {x}%.',
    there_are_other_items_you_may_like: '<span>Есть и другие предметы</span>, которые могут Вам понравиться...',
    available_variants: 'Доступные варианты',
    picture: {
      playside: 'Игровая сторона',
      backside: 'Обратная сторона',
      steam: 'Изображение на торговой площадке Steam',
    },
    buy_orders_not_available: 'Заказы на покупку в настоящее время недоступны',
    confirm_price_change: 'Подтвердить изменение цены',
    are_you_sure_to_change_price: 'Вы уверены, что хотите изменить цену на {price}?',
  },
  bumps: {
    heading: 'Хотите <span class="text-cp">продать свои предметы быстрее</span>, не снижая их цену?',
    subheading: 'У нас есть кое-что для Вас!',
    how_it_works: '<span class="text-cp">Как</span> это работает?',
    description: 'В BitSkins у нас есть опция "Продвигать", которая позволяет Вам размещать свои предметы на странице магазина и в некоторых других местах веб-сайта. Это идеальное решение для тех, кто хочет ускорить процесс продажи предметов без необходимости снижать их цену. Когда Вы продвигаете предмет, его увидит больше людей, и вероятность его продажи увеличится. Вы можете начать продвигать свои предметы, начиная всего с $0,75 или даже меньше (пожалуйста, ознакомьтесь с нашими пакетами продвижения)',
    your_active_x_autobumps: 'Ваши активные продвижения {x}.',
    bumps_packages: 'Пакеты продвижения',
    bumps: 'продвижения',
    bumps_title: 'Продвижения',
    available_bumps: 'Доступные продвижения',
    buy_selected_package: 'Купить выбранный пакет',
    when_you_bump: 'Когда Вы продвигаете предмет, он будет отображаться в следующих местах:',
    step_1_title: 'На странице магазина в <span class="text-cp">верхней панели</span>',
    step_2_title: 'На странице магазина в <span class="text-cp">главном разделе</span>',
    step_2_text: '(Только если параметр сортировки установлен как «Избранное». Это параметр по умолчанию.)',
    step_3_title: 'На <span class="text-cp">главной странице</span>',
    step_4_title: 'На странице предмета в разделе <span class="text-cp">похожие предметы</span>.',
    step_5_title: 'В разделе <span class="text-cp">предложенные предметы</span>',
    after_bumping: '<span class="text-cp">После продвижения</span> предмета он будет показан <span class="text-cp">на первом месте</span> в каждом разделе. Однако <span class="text-cp">если после тебя кто-то другой продвинет свой предмет</span>, то твой предмет будет перемещён на <span class="text-cp">второе место</span>. Твой предмет будет виден в каждом разделе до тех пор, пока не будет достаточно продвижений, которые вытеснят его из раздела.',
    how_to_bump: '<span class="text-cp">Как</span>продвигать свой товар?',
    how_to_1: 'Откройте меню предмета',
    how_to_2: 'Выберите опцию <span class="text-cp">продвигать</span>',
    how_to_3: 'Выберите тип продвижения',
    how_to_4: 'Готово!',
    table: {
      item: 'Предмет',
      quantity: 'Количество',
      left: 'Осталось',
      period: 'Период',
      created_at: 'Создано в',
      updated_at: 'Обновлено в',
      next_bump_at: 'Следующее продвижение в',
      action: 'Действие',
      status: 'Статус',
    },
    auto_enabled: 'Включена функция автоматического продвижения',
    auto_disabled: 'Автоматическое продвижение отменено',
    single_bumped: 'Вы успешно продвинули этот предмет.',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Подтвердите отмену заказов на покупку.',
    are_you_sure_that_you_want_to_cancel: 'Вы уверены, что хотите отменить все свои заказы на покупку?',
    create_buy_order: 'Создайте <span class="text-cp">заказ на покупку</span>.',
    predict_place_in_queue: 'Предсказать место в очереди',
    your_place_in_the_queue: 'Ваше место в очереди:',
    may_purchase_items_with_trade_hold: 'В заказах на покупку могут быть приобретены товары с удержанием обмена.',
    create_a_buy_order_for_this_item: 'Создайте заказ на покупку этого предмета',
    no_buy_orders_found: 'Не найдено ни одного заказа на покупку',
    position_in_queue: 'Положение в очереди',
    this_is_your_buy_order: '(Это Ваш заказ на покупку).',
    skin_name: 'Название скина:',
    offers_on_market: 'предложения на торговой площадке',
  },
  instant_sell: {
    confirmation: 'Мгновенное подтверждение продажи',
    you_can_sell_x: 'Вы можете мгновенно продать AWP | Asiimov (После полевых испытаний) и получить $10.',
    the_funds_will_be_credited: 'Средства будут зачислены на Ваш счет немедленно. Если Вы хотите продолжить, нажмите «Продать мгновенно»',
  },
  sort: {
    select_option: 'Выберите вариант',
    apply: 'Применить',
    clear: 'Очистить',
    default_order_placeholder: 'Выберите вариант',
    select_order_placeholder: 'Выберите сортировку',
    default_sort: 'Сортировка по умолчанию',
    custom_sort: 'Пользовательская сортировка',
    field: {
      price: 'Цена',
      discount: 'Скидка',
      id: 'Дата добавления',
      bumped_at: 'Рекомендуемые',
      suggested_price: 'Предлагаемая цена',
      asset_id: 'Дата добавления',
      float_value: 'Степень износа',
      paint_index: 'Paint index',
      paint_seed: 'Узор (Paint seed)',
      extras_1: 'Дополнительная ценность',
      extras_1_fade: 'Градиент',
      amount: 'Сумма',
      name: 'Название',
    },
    order: {
      price: {
        asc: 'Сначала самый дешевый',
        desc: 'Сначала самый дорогой',
      },
      discount: {
        desc: 'Сначала самый высокий',
      },
      id: {
        asc: 'Сначала самый старый',
        desc: 'Сначала самый новый',
      },
      asset_id: {
        asc: 'Сначала самый старый',
        desc: 'Сначала самый новый',
      },
      bumped_at: {
        desc: 'По умолчанию',
        asc: '',
      },
      default: {
        asc: 'Сначала самый низкий',
        desc: 'Сначала самый высокий',
      },
    },
  },
  pagination: {
    showing: 'Показано',
    to: 'до',
    of: 'из',
    records: 'предметов',
  },
  popups: {
    click_confirmation_link: 'Пожалуйста, проверьте свой почтовый ящик и нажмите ссылку подтверждения, чтобы завершить процесс.',
    steam_login_issue: {
      title: 'Проблема со входом в Steam',
      an_error_occured: 'При попытке входа в систему через Steam произошла ошибка. Пожалуйста, попробуйте еще раз.',
    },
    steam_inventory_private: {
      title: 'Ваш инвентарь Steam является <span class="text-cp">скрытым</span>',
      we_were: 'Нам не удалось загрузить Ваш инвентарь Steam. Пожалуйста, измените статус вашего инвентаря на публичный.',
      you_can: 'Сделать это можно в настройках Steam. Имейте в виду, что может пройти несколько минут, прежде чем мы обнаружим изменения.',
      steam_settings: 'Настройки Steam',
    },
    account_deletion_in_progress: {
      title: 'Идет удаление аккаунта...',
      process_started: 'Вы запустили процесс удаления аккаунта.',
      account_will_be_deleted: 'Ваша учетная запись будет удалена ',
      cancel_deletion: 'Отмена удаления',
      confirm_deletion: 'Подтвердите удаление',
      check_your_email: 'Проверьте свою электронную почту',
    },
    account_deletion_confirm: {
      title: 'Подтвердите удаление аккаунта',
      subtitle: 'Вы уверены, что хотите удалить свой аккаунт?',
      once_you_confirm: 'После подтверждения Вы автоматически выйдете из системы, и все данные Вашей учетной записи будут окончательно удалены через две недели. В течение этих двух недель Вы сможете отменить процесс удаления, войдя в свою учетную запись.',
      once_your_account_is: 'После удаления Вашей учетной записи Вы сможете создать новую учетную запись BitSkins, войдя на веб-сайт.',
      however_you_will_not: 'Однако у вас не будет доступа к удаленным данным.',
      if_you_want_to_continue: 'Если Вы хотите продолжить, нажмите «Подтвердить» и нажмите ссылку подтверждения в электронном письме, которое мы Вам отправили.',
      login: 'Чтобы подтвердить удаление аккаунта, Вам нужно войти в систему',
      canceled: 'Удаление аккаунта отменено',
      confirmed: 'Удаление аккаунта подтверждено',
    },
    account_deletion_check_your_email: {
      title: 'Проверьте свою электронную почту',
      to_complete: 'Чтобы завершить процесс удаления учетной записи, нажмите ссылку подтверждения в электронном письме, которое мы отправили Вам.',
    },
    twofa_enable: {
      already_done: 'Вы уже включили 2FA.',
      setup_email_before: 'Для того чтобы включить 2FA, Вам нужно сначала настроить электронную почту.',
      twofa_authentication_adds: 'Двухфакторная аутентификация (2FA) добавляет дополнительный уровень безопасности Вашей учетной записи, требуя двух методов (факторов) для проверки Вашей личности. Включение 2FA настоятельно рекомендуется для обеспечения безопасности Вашей учетной записи, поскольку это предотвращает нежелательный вход в систему без доступа к дополнительному коду 2FA.',
      setup_twofa: 'Настройте двухфакторную аутентификацию',
      if_you_dont_have_an_authenticator_app: 'Если у Вас <span class="text-cp">нет</span> приложения для аутентификации',
      we_recommend: '<p>Мы рекомендуем <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> или <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> для пользователей Android и iOS. Если Вы хотите использовать приложение на компьютере, то можете скачать и установить <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> или воспользоваться <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">расширение Google Authenticator</a> в Вашем браузере.',
      scan_the_qr_code: '<span class="text-cp">Отсканируйте</span> QR-код',
      open_your_authenticator_app: 'Откройте своё приложение для аутентификации и отсканируйте QR-код или введите секретный ключ вручную.',
      secret_key: 'Секретный ключ',
      this_secret_key_will_be_valid_for_x_seconds: 'Этот секретный ключ будет действовать в течении <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: 'Сохрани этот секретный ключ в надёжном месте. Он позволит Вам восстановить доступ к своим кодам 2FA<br>, когда Вы потеряеете доступ к приложению для аутентификации.',
      enter_the_6_digit_code: 'Введите <span class="text-cp">6-значный код</span>, сгенерированный твоим приложением для аутентификации.',
      enter_code_from_the_email: 'Введите код из <span class="text-cp">электронной почты</span>.',
      enter_the_verification_code: 'Введите проверочный код, который мы отправили на <span class="text-cp">{email}</span>.',
      desktop: 'Рабочий стол',
    },
    twofa_enabled: {
      now_your_account_is: 'Теперь Ваш аккаунт защищён двухфакторной аутентификацией.',
      all_future_logins: 'Теперь для всех будущих входов в систему Вам потребуется ввести код, предоставленный Вашим приложением для аутентификации.',
    },
    twofa_enter_code: 'Введите код 2FA, сгенерированный Вашим приложением для аутентификации.',
    twofa_disable: {
      title: 'Отключить двухфакторную аутентификацию',
      enter_the_6_digit_code: 'Введите 6-значный код, сгенерированный Вашим приложением для аутентификации.',
      cannot_access: 'Не можете получить доступ к своему коду подтверждения? Пожалуйста, свяжитесь с нами в ',
    },
    twofa_disabled: 'Ваша учётная запись больше не защищена двухфакторной аутентификацией.',
    order_unable_to_process: {
      title: 'Мы не смогли <span class="text-cr">обработать Ваш заказ</span>.',
      an_error_occurred: 'При обработке Вашего заказа произошла ошибка.<br> Пожалуйста, вернитесь на страницу оформления заказа и попробуйте оформить его снова.',
      back_to_checkout: 'Вернуться к оформлению заказа',
      back_to_item: 'Вернуться к предмету',
      information: 'Если эта ошибка возникает часто, Вам следует связаться с нами через <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">страницу поддержки</a>, указав код ошибки:',
    },
    phone_number_add: {
      title: 'Добавьте свой номер телефона',
      to_continue: 'Чтобы продолжить, Вам сначала необходимо добавить свой номер телефона в свою учетную запись.',
      add_number: 'Добавить номер',
    },
    phone_number_confirmed: {
      title: 'Номер телефона подтвержден',
      your_phone_number: 'Ваш номер телефона был подтверждён.',
    },
    phone_number_verify: {
      title: 'Подтвердите свой номер телефона',
      to_verify: 'Чтобы подтвердить свой номер телефона, Вам нужно ввести проверочный код, который мы отправили на',
      enter_sms_code: 'Введите SMS-код',
      you_cannot_update: 'На данном этапе Вы не можете обновить свой номер телефона. Вы сможете сделать это через {minutes} минут.',
    },
    phone_number_verification_in_progress: {
      title: 'Выполняется проверка номера телефона',
      if_you_wish: 'При желании Вы можете обновить свой номер телефона или повторно отправить проверочный код.',
      send_code: 'Отправить код',
    },
    email_address_add: {
      your_email_address: 'ваш адрес электронной почты',
      by_providing_my_email: 'Предоставляя свой адрес электронной почты, я соглашаюсь получать маркетинговые сообщения',
      verification_in_progress: 'Выполняется проверка электронной почты',
      to_verify: 'Чтобы подтвердить свой адрес электронной почты, Вы должны нажать на ссылку подтверждения в письме, которое мы отправили на',
      if_you_wish: 'При желании Вы можете обновить свой адрес электронной почты или повторно отправить ссылку активации.',
    },
    email_address_verify: {
      we_are_verifying: 'Мы проверяем Ваш адрес электронной почты, и это может занять некоторое время...',
      confirmed: 'Ваш адрес электронной почты был подтверждён.',
    },
    email_address_confirmed: {
      title: 'Адрес электронной почты подтвержден',
      your_email_address: 'Ваш адрес электронной почты был подтверждён.',
    },
    enter_your_trade_url: {
      title: 'Вставьте свою<span class="text-cp">ссылку на обмен</span>',
      to_continue: 'Чтобы продолжить, Вам сначала необходимо настроить свою ссылку на обмен. Вы найдете это',
      your_trade_url: 'Ваша ссылка на обмен',
    },
    password_reset_enter_email: {
      forgot: 'Забыли свой',
      password: 'пароль?',
      dont_worry: 'Не волнуйтесь, введите свой адрес электронной почты ниже.',
      we_will_send: 'Мы пришлём Вам ссылку для сброса пароля.',
      send_reset_link: 'Отправить ссылку на сброс',
      if_this_email: 'Если этот адрес электронной почты связан с аккаунтом BitSkins,',
      you_will_receive: 'вы получите письмо со ссылкой для сброса пароля.',
    },
    password_reset_new_password: {
      enter_your: 'Введите свой',
      new_password: 'новый пароль',
      enter_password: 'Введите пароль',
      repeat_password: 'Повторите пароль',
      save_password: 'Сохранить пароль',
    },
    link_expired: {
      title: 'Срок действия ссылки истек',
      the_process_cannot: 'Этот процесс не может быть завершен. Срок действия ссылки уже истек.',
      go_to_settings: 'Перейдите к настройкам',
    },
    wrong_link: {
      title: 'Неправильная ссылка',
      we_were_unable: 'Мы не смогли обработать Ваш запрос. Вы перешли по неправильной ссылке.',
    },
    trade_preparing: {
      title: 'Мы готовим ваше предложение обмена',
      processing: 'Это может занять несколько секунд...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'Ваше предложение обмена <span class="text-cp">было отправлено</span>',
    },
    trade_done: {
      title: 'Предложение обмена было<span class="text-cp">принято</span>.',
      listed: 'Вы успешно выставили свои предметы на продажу. Вы можете управлять ими на вкладке <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">продажа</a>.',
      see_listed: 'Посмотреть свои размещенные предметы',
      withdrawn: 'Вы успешно вывели свои предметы.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'Ваше предложение обмена было',
      declined: 'отклонено',
      if_you: 'Если Вы не отклонили его самостоятельно, это означает, что кто-то использует Вашу учетную запись, и Ваши предметы могут оказаться под угрозой кражи.',
      to_stay: 'Чтобы защитить свои предметы, следует действовать быстро и выполнить следующие шаги:',
      step_revoke: 'Отвяжите свой Steam Web API ключ.',
      step_revoke_btn: 'ОТВЯЗАТЬ API КЛЮЧ',
      step_password: 'Измените свой пароль в Steam.',
      step_password_btn: 'ИЗМЕНИТЬ ПАРОЛЬ',
      step_deauth: 'Деавторизуйте все устройства в Steam.',
      step_deauth_btn: 'ДЕАВТОРИЗАЦИЯ УСТРОЙСТВ',
      step_trade: 'Создайте новую ссылку на обмен в Steam.',
      step_trade_btn: 'СОЗДАТЬ НОВУЮ ССЫЛКУ НА ОБМЕН',
      step_new: 'Установите новую ссылку на обмен в BitSkins.',
      step_new_btn: 'УСТАНОВИТЬ НОВЫЙ ССЫЛКУ НА ОБМЕН',
      step_try: 'Попробуйте внести свои предметы еще раз и посмотрите, сохранится ли проблема.',
      step_try_if: 'Если это продолжает происходить, прекратите все сделки и свяжитесь с нашей службой поддержки.',
      contact_support: 'Связаться со службой поддержки',
      information: 'Имейте в виду, что наши сотрудники и боты никогда не будут запрашивать какие-либо пополнения через чат Steam, Discord или где-либо еще — любой, кто утверждает, что является администратором и т. д., является лжецом и, скорее всего, хочет Вас обмануть. Оставайтесь в безопасности!',
    },
    trade_failed: {
      offer_failed_title: 'Предложение обмена <span class="text-cr">не удалось</span>.',
      offer_failed_text: 'К сожалению, Ваше предложение обмена не удалось. Пожалуйста, попробуйте еще раз.',
      offer_failed_to_create_title: '<span class="text-cr">Не удалось</span> создать предложение обмена',
      offer_failed_to_create_text: 'К сожалению, мы не смогли создать Ваше предложение обмена. Пожалуйста, попробуйте еще раз.',
      contact_support: 'Если эта ошибка возникает часто, Вам следует связаться с нами через <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">страницу поддержки</a>.',
      support_page: 'страница поддержки',
      cannot_process: 'Мы не можем обработать Ваше предложение обмена',
      unfortunately_we_were_unable: 'К сожалению, мы не смогли обработать Ваше предложение обмена. Скорее всего, у Вас уже есть активное предложение обмена на эти предметы.',
    },
    items_not_available: {
      title: 'Предметы больше не доступны для продажи',
      unfortunately: 'К сожалению, предметы из Вашей корзины <span class="text-cy-secondary">больше не доступны для продажи</span>.',
      dont_worry: 'Не волнуйтесь, на странице магазина Вы можете найти множество предметов.',
      unavailable_items: 'Недоступные предметы',
      back_to_market: 'Вернуться в магазин',
    },
    bump_purchase_confirmation: {
      title: 'Подтверждение покупки',
      do_you_want_to_purchase: 'Вы хотите приобрести <span class="text-cp">{quantity} продвижений</span> за <span class="text-cp">{price}</span>?',
      bumps_package: 'пакет продвижений',
    },
    bump_start: {
      title: 'Продвигайте свой предмет',
      bump_your_item: 'Продвигайте свой товар, чтобы разместить его на странице магазина и в нескольких других местах веб-сайта. Это поможет Вам продать предмет быстрее, поскольку его заметит больше людей. Если Вы хотите узнать больше о том, как работает функция продвижения',
      click_here: 'нажмите здесь',
      single_bump: 'Одиночное продвижение',
      autobumps: 'Автоматические продвижения',
      one_bump: '1 продвижение',
      this_option_single_bump: 'При этой опции Ваш предмет будет продвигаться только один раз, и стоит это <span class="text-cp">$0,75</span>. Если на Вашем счету уже есть доступные продвижения, то с Вашего баланса ничего не будет списано.',
      this_option_autobumps: 'Эта опция будет продвигать Ваш предмет каждый выбранный период времени. Если на Вашем счету уже есть доступные продвижения, то с Вашего баланса ничего не будет списано. Если же у Вас закончились продвижения, то <span class="text-cp">$0,75</span> будет списываться с Вашего баланса при каждом продвижении. <span class="text-cp">Вы можете заранее приобрести большее количество продвижений</span> и при этом <span class="text-cp">сэкономить немного денег</span> - прокрутите страницу вниз, чтобы ознакомиться с пакетами продвижений.',
      bump_every: 'Продвинуть все',
      bumps_amount: 'Количество продвижений',
      delayed_start: 'Отложенный старт',
      delayed_start_description: 'Выбрав эту опцию, Ваше первое продвижение будет отложено на выбранный период времени.',
    },
    bump_stop: {
      title: 'Остановить автоматические продвижения',
      do_you_want: 'Хотите ли вы прекратить автоматические продвижения для этого предмета?',
    },
    bulk_buy: {
      bulk_buy: 'Оптовая <span class="text-cp">покупка</span>.',
      maximum_items_you_can_buy: 'Максимум предметов, которые Вы можете купить за эту цену:',
      may_purchase_items_with_trade_hold: 'Функция оптовая покупка может приобретать предметы с удержанием обмена.',
    },
  },
  affiliate: {
    ad_info: 'Если Вы не видите окно, попробуйте отключить adblock.',
    affiliate_code: 'код партнера',
    affiliate_link: 'ссылка партнера',
    level: 'Уровень',
    levels: '<span class="text-cp">Партнерские </span>уровни',
    our_levels: 'Наши уровни',
    your_code: '<span class="text-cp">Ваш партнерский </span>код',
    your_affiliate_statistics: '<span class="text-cp">Твоя партнерская </span>статистика',
    earn_money_by_simply_sharing: '<span class="text-cp">Зарабатывайте деньги</span>, просто делясь своей любовью к BitSkins со своей аудиторией!',
    percent_from_sale_fee: '{value}% от комиссии за продажу',
    join_the_bitskins_affiliate: 'Присоединяйтесь к партнерской программе BitSkins и получайте комиссионные с каждой продажи, осуществленной по Вашей уникальной партнерской ссылке. Независимо от того, есть ли у Вас большое количество подписчиков или всего несколько близких друзей, чем больше Вы поделитесь, тем больше Вы заработаете.',
    tile_1_title: 'Поделитесь BitSkins со своей аудиторией',
    tile_1_description: 'Создайте свою собственную партнерскую ссылку за считанные секунды и начните делиться ею со своими друзьями или аудиторией.',
    tile_2_title: 'Наблюдайте за тем, как растёт Ваша прибыль',
    tile_3_title: 'Получите свой заработок',
    tile_3_description: 'Средства, полученные от партнерской программы, можно потратить на покупку предметов или вывести из BitSkins. Вам решать!',
    kyc_you_cannot_use: 'Вы не можете воспользоваться партнёрской системой, потому что не прошли процедуру KYC. Вы можете начать процесс проверки прямо сейчас.',
    your_percentage: 'Ваш процент',
    generated: 'Сгенерированный',
    individual_affiliate_program: 'Индивидуальная партнёрская программа',
    if_you_or_your_business: 'Если Вы или Ваш бизнес вовлечен в индустрию esports или генерирует большой охват в социальных сетях, обращайтесь к нам через <span>partnership{\'@\'}bitskins.com</span>. Мы сможем предложить Вам индивидуальные партнёрские условия.',
    invited_referrals: 'Приглашённые рефералы',
    active_referrals: 'Активные рефералы',
    your_percentage_sales_fee: 'Ваш процент с продаж',
    your_total_earnings: 'Ваш общий заработок',
    available_earnings: 'Доступный заработок',
    you_can_claim_your_earnings_one_a_day: 'Вы можете получить свой доход один раз в день. Как только вы получите его, он появится на вашем балансе для вывода в течение 24 часов. Минимальная сумма к выплате составляет',
    to_reach_the_next_level: 'Чтобы выйти на следующий уровень и зарабатывать более высокие комиссионные, Вам нужно генерировать <span class="text-cp">{x}</span> в продажах через своих рефералов.',
    any_user_that_registers_from_your_affiliate_link: 'Любой пользователь, который зарегистрируется по Вашей партнерской ссылке, будет автоматически назначен Вашим рефералом',
    my_earnings: '<span class="text-cgs">Мой</span> заработок',
    referred_users: '<span class="text-purple">Приглашенные</span> пользователи',
    code_updated: 'Партнерский код успешно обновлен',
    not_enough_money: 'Недостаточно денег для перевода',
    account: 'Счет',
    referrals_sales: 'История продаж рефералов',
  },
  profile: {
    hi: 'Привет',
    nav: {
      account: 'Счет',
      wallet: 'Кошелек',
      transactions: 'Транзакции',
      statistics: 'Статистика',
      affiliate: 'Партнерская программа',
      company: 'Компания',
      trades: 'Обмены',
      items_history: 'История предметов',
    },
    top_star: {
      you_are: 'Вы',
      top_star: 'ЗВЕЗДА',
      good_to_see_you: 'Добро пожаловать "{username}", очень рады видеть Вас в BitSkins!',
      appreciate_using: 'Мы признательны, что Вы решили использовать нашу платформу,',
      extra_settings: 'и поэтому мы подготовили для Вас несколько дополнительных функций.',
      show_nickname_selling: 'Показывать мой ник на странице предмета при продаже',
      show_nickname_store: 'Выделять мой ник на странице магазина',
    },
    basic: {
      basic_information: 'Основная информация',
      username: 'Имя пользователя',
      change_username: 'Изменить имя пользователя',
      registration_date: 'Дата регистрации',
      email: 'Электронная почта',
      change_email: 'Изменить почту',
      password: 'Пароль',
      change_password: 'Изменить пароль',
      phone: 'Номер телефона',
      change_phone: 'Сменить телефон',
      hide_balance: 'Скрыть свой баланс',
      hide_balance_description: 'Сумма средств будет скрыта в заголовке, она все равно будет видна после нажатия на кошелек.',
    },
    security: {
      you_can_access_your_account: 'Вы можете получить доступ к своей учетной записи через ключ API. Наша документация по API находится',
      api_status: 'Состояние API',
      security: 'Безопасность',
      twofa: 'Двухфакторная аутентификация',
      temporarily_block_my_account: 'Временно заблокировать мой аккаунт',
      temporarily_block_title: 'Временно <span class="text-cr">заблокировать мой аккаунт</span>',
      temporarily_block_description: 'Если Вы считаете, что Ваш аккаунт был взломан, Вы можете временно заблокировать его. Мы разблокируем Ваш аккаунт после обращения в нашу службу поддержки.',
      temp_blocked: 'Ваш аккаунт был временно заблокирован.\nnПожалуйста, свяжитесь с нашей службой поддержки, чтобы прояснить ситуацию.',
      block_my_account: 'Заблокировать аккаунт',
      delete_account: 'Удалить аккаунт',
      delete_my_account: 'Удалить мой аккаунт',
      sessions: 'Сессии',
      close_all_sessions: 'Закрыть все сессии',
      current_session: 'Текущая сессия',
      active_sessions: 'Активные сессии',
      no_other_sessions: 'Никаких других сессий',
      removed: 'Удалено',
      online: 'Онлайн',
      api_key: 'Ключ API',
      api_key_not_available: 'API ключ виден только один раз во время его создания',
      sensitive_hidden: 'Скрытая конфиденциальная информация',
      ip_whitelist: 'IP разрешенный список',
      add_ip_to_whitelist: 'Добавить IP в разрешенный список',
      disable_api_confirm: 'Подтвердите отключение доступа API',
      disable_api_content: 'Вы уверены, что хотите отключить доступ API для своей учетной записи?',
    },
    store: {
      my_store: 'Мой магазин',
      store: 'магазин',
      store_url: 'Адрес магазина',
      store_alias: 'Псевдоним магазина',
      id_store: 'ID МАГАЗИНА',
      hide_store: 'Скрыть страницу своего магазина',
      url_copied: 'Ссылка магазина скопирована',
      total_items: 'Всего предметов:',
      games: 'Игры:',
    },
    setting: {
      account_email: 'Электронная почта аккаунта',
      update_email: 'Обновить электронную почту',
      setup_email: 'Настройка электронной почты',
      update_password: '<span class="text-cp">Обновить</span> пароль',
      set_password: '<span class="text-cp">Установить</span> пароль',
      enter_current_password: 'Введите текущий пароль',
      password_changed: 'Пароль изменен',
      current_password: 'Текущий пароль',
      enter_new_password: 'Введите новый пароль',
      repeat_new_password: 'Повторите новый пароль',
      save_new_password: 'Сохранить новый пароль',
      new_password: 'Новый пароль',
      repeat_password: 'Повторите пароль',
      account_2fa: 'Учетная запись 2FA',
      enable_2fa: 'Включить 2FA',
      disable_2fa: 'Отключить 2FA',
    },
    transaction: {
      amount: 'Сумма',
      type: 'Тип',
      details: 'Подробности',
      fee: 'Плата',
      buyer_country: 'Страна покупателя',
      seller_country: 'Страна продавца',
      price: 'Цена',
      item_name: 'Название предмета',
      transaction_history: 'История транзакций',
      operation: 'Операция',
      trade_id: 'ID обмена',
      loading_trade_offers: 'Загрузка предложений обмена',
      no_trades_found: 'Предложений на обмен не найдено',
      id: 'ID',
      date: 'Дата',
      game: 'Игра',
      items: 'Предметы',
      status: 'Состояние',
      time_left: 'Оставшееся время',
      action: 'Действие',
      trades_active: 'Активные обмены',
      trades_history: 'История обменов',
      balance: 'Баланс',
      history: 'История транзакций',
      pending: 'Незавершенные операции',
      reports: 'Экспортированные отчеты',
      active_locks: 'Активные блокировки',
      export: 'Экспорт',
      export_to_csv: 'Экспортировать в формат .CSV',
      export_description: 'Выберите месяц и год, за которые Вы хотите сформировать отчет.',
      the_report_will_appear_in_the: 'Отчет появится',
      tab_once_the_export_process_is_complete: 'на вкладке после завершения процесса экспорта.',
    },
  },
  fee: {
    individual: 'Физическое лицо',
    individual_fee: 'индивидуальная комиссия',
    custom_sale_fee: 'Ваша индивидуальная комиссия за продажу',
    your_current_fees: 'Ваши текущие комиссии',
    high_tier: 'Высокий уровень',
    fee: 'Комиссия',
    fee_up_to: 'комиссия',
    sale_fee: 'Комиссия за продажу',
    sales_fees: 'Комиссии с продаж',
    see_all_levels: 'Посмотреть все уровни',
    you_are_on: 'Вы находитесь на',
    maximum_sales_fee: 'Максимальная комиссия за продажу: {value}',
    your_total_sale_volume: 'Ваш общий объем продаж на данный момент составляет',
    sales_fees_will_be_lowered: 'Комиссионные с продаж будут снижаться по мере того, как Вы будете продавать больше товаров.',
    level: 'уровень',
    your_level: 'Ваш уровень:',
    progress: 'Прогресс:',
    max_level: 'Максимальный уровень',
    next_level: 'Следующий уровень:',
    total_income: 'Общая прибыль',
    total_revenue: 'Общий доход',
    sold_items: 'Проданные предметы',
    page: {
      sales_fees_depends_on_two_factors: 'В BitSkins <span class="text-cp">комиссии с продаж</span> зависят от двух факторов:',
      the_price: '1. Цена, за которую Вы продаете свой предмет',
      the_listing_type: '2. Тип размещения:',
      listing_type_public: 'Публичный — Ваш предмет виден всем пользователям сайта.',
      listing_type_private: 'Частный — Ваш товар виден только тем, с кем Вы поделитесь ссылкой.',
      fee_explanation: 'Чем выше цена, по которой Вы продаете свой предмет, тем меньшую комиссию за продажу Вы заплатите. Стандартная комиссия за продажу составляет от 2,5% (для частных объявлений) до максимум 10% (для публичных объявлений). Кроме того, у нас есть 5 различных уровней продаж, которые позволят Вам еще больше снизить комиссию за продажу. Правило простое: чем больше Вы продаете, тем меньшую комиссию Вы платите. Вы можете снизить комиссию за продажу до 2,4% (для частных объявлений) или до 9,8% (для публичных объявлений). Наша система комиссий прозрачна и не содержит скрытых комиссий.',
      default_sales_fees_title: '<span class="text-cp">По умолчанию</span> комиссия за продажу.',
      default_sale_fees_description: 'Если Вы только начинаете и еще не продали ни одного предмета, то Ваша комиссия за продажу будет следующей:',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">Как уменьшить</span> мою комиссию за продажу?',
      how_to_reduce_my_sales_fees_description: 'В BitSkins мы имеем 5 уровней продаж. Каждый из них (кроме 1-го уровня) снижает твою комиссию за продажу на 0,05%. Чтобы повысить свой уровень, Вам нужно продавать предметы в определённом ценовом диапазоне.',
      sales_fees_levels: 'Продажи <span class="text-cp">уровни комиссий</span>',
      price_range: 'Ценовой диапазон',
      total_sales: 'Общие продажи',
      fee_reduced_by: 'Комиссия уменьшилась на',
      individual_sales_fees_title: 'Комиссия за индивидуальные продажи',
      individual_sales_fees_description: 'Если Вы активно используете BitSkins и Ваш месячный оборот составляет не менее <span class="span text-csfl6">{amount}4, не стесняйтесь обращаться к нам. Мы можем предложить Вам  5ещё меньшую комиссию за продажу5 и 3дополнительную помощь3.',
    },
  },
  copy: {
    text_copied: 'Текст скопирован',
    cannot_copy: 'Невозможно скопировать',
    name_copied: 'Назваание скопировано',
    cannot_copy_name: 'Невозможно скопировать название',
    copy_link: 'Скопировать ссылку',
  },
  share: {
    share_on_twitter: 'Поделиться в Twitter',
    share_on_facebook: 'Поделиться на Facebook',
    share_on_telegram: 'Поделиться в Telegram',
  },
  discord: {
    discord: 'Discord',
    already_connected: 'Уже подключен',
    something_went_wrong: 'Что-то пошло не так',
    success: 'Успех!',
    loading: 'Загрузка...',
    connect_with_discord: 'Подключиться с Discord',
  },
  telegram: {
    already_connected: 'Уже подключен',
    something_went_wrong: 'Что-то пошло не так',
    success: 'Успех!',
    loading: 'Загрузка...',
  },
  error: {
    error_404: 'Ошибка 404',
    page_not_found: 'Страница не найдена',
  },
  kyc: {
    description_1: 'Чтобы обеспечить безопасность транзакций, осуществляемых через наш веб-сайт, и соблюдать применимые правила AML/KYC, мы требуем, чтобы Вы прошли процесс проверки данных (KYC). Существует три уровня проверки. Каждый из уровней увеличивает или полностью снимает лимиты и открывает доступ к новым способам оплаты.',
    description_2_start: 'Подробные условия, касающиеся процесса проверки KYC, описаны в наших Условиях использования. Мы хотели бы заверить Вас, что все предоставленные Вами данные будут использованы в соответствии с',
    description_2_end: 'Начав процесс проверки KYC, Вы даете согласие на обработку нами Ваших данных в юридически обоснованных целях.',
    personal_data: 'Персональные данные',
    first_name: 'Имя',
    middle_name: 'Отчество',
    last_name: 'Фамилия',
    street_name: 'Название улицы',
    street_number: 'Номер улицы',
    postal_code: 'Почтовый индекс',
    city: 'Город',
    province: 'Область',
    country: 'Страна',
    start_kyc_verification: 'Проверка аккаунта KYC',
    upload: 'Загрузите',
    uploaded: 'Загружено',
    image_uploaded: 'Изображение загружено',
    document_type: {
      id: 'ID',
      driving_license: 'Водительское удостоверение',
      passport: 'Паспорт',
      other: 'Другое',
    },
    limit: {
      crypto_withdraw: 'Годовой лимит на вывод криптовалюты в размере {amount}',
      crypto_withdraw_unlimited: 'Неограниченный вывод криптовалюты',
      non_crypto_withdraw: 'Годовой лимит на снятие некриптовалюты составляет {amount}',
      non_crypto_withdraw_unlimited: 'Неограниченный вывод средств в некриптовалюте',
      crypto_deposit: 'Годовой лимит некриптовалютных пополнений составляет {amount}',
      crypto_deposit_unlimited: 'Неограниченные криптовалютные пополнения',
      non_crypto_deposit: 'Годовой лимит некриптовалютных пополнений составляет {amount}',
      non_crypto_deposit_unlimited: 'Неограниченное количество некриптовалютных пополнений',
    },
    your_kyc_verification: 'Ваша проверка KYC',
    your_kyc_needs_an_update: 'Ваш KYC нуждается в <span class="color-update">обновлении</span>.',
    need_update_reason: 'К сожалению, нам не удалось одобрить Вашу учетную запись по следующим причинам:',
    open_support: 'Открыть службу поддержки',
    your_kyc_has_been_denied: 'Ваш KYC <span class="color-denied">был отклонен</span>.',
    denied_description: 'Ваш KYC был отклонён, поэтому Вы не можете пройти проверку KYC ещё раз.',
    deleted_description: 'Ваш KYC был отклонён.Вы можешь пройти процесс верификации ещё раз.',
    please_contact_our: 'Пожалуйста, свяжитесь с нашей',
    support: 'службой поддержки',
    clarify_the_situation: 'чтобы прояснить ситуацию.',
    your: 'Ваш',
    kyc_title: 'KYC <span class="text-cp">верификация</span>',
    verification: 'верификация',
    pending: 'ожидается',
    pending_description: 'Это все! Спасибо, что прошли процедуру проверки. Ваши данные успешно отправлены. Мы сделаем все возможное, чтобы проверить Вашу заявку как можно скорее. Обычно это занимает не более 12 часов. Мы отправим Вам электронное письмо, как только Ваша учетная запись будет одобрена. Мы ценим ваше терпение.',
    do_you_need_help: 'Вам нужна помощь? Обращайтесь в наш',
    support_center: 'центр поддержки',
    back_to_kyc: 'Вернуться к KYC',
    go_to_home: 'Перейти на главную',
    level_0: 'Уровень 0',
    level_1: 'Уровень 1',
    level_2: 'Уровень 2',
    limits: 'Ограничения',
    benefits: 'Преимущества',
    requirements: 'Требования',
    no_requirements: 'Никаких требований',
    proof_of_address: 'Подтверждение адреса',
    all_benefits_from_the_basic_level: 'Все преимущества, начиная с базового уровня',
    personal_information: 'Личная информация',
    identity_document: 'Документ, удостоверяющий личность',
    selfie: 'Селфи',
    all_benefits_from_level_1: 'Все преимущества c 1 уровня',
    current: 'Текущий',
    upending: 'В ожидании',
    update: 'Обновление',
    verification_blocked: 'Верификация заблокирована',
    verify_now: 'Проверить сейчас',
    you_need_to_upgrade_to_level_1: 'Вам необходимо повысить до 1 уровня',
    upgrade_to_level_1: 'Повысить до 1 уровня',
    upgrade_to_level_2: 'Повысить до 2 уровня',
    kyc_verification: 'Верификация KYC',
    kyc_verification_span: '<span class="color-primary">KYC верификация',
    kyc_verification_required: 'Требуется верификация KYC',
    everything_done: 'Всё сделано!',
    proof_of_residency: 'Подтверждение места жительства',
    you_current_residential_address: 'Ваш текущий адрес проживания',
    only_x_minutes: 'Всего {minutes} минут!',
    identity_verification: 'Проверка личности',
    take_a_selfie: 'Сделай селфи',
    step: 'Шаг {step}',
    country_of_residence: 'Страна проживания',
    full_name: 'Полное имя',
    date_of_birth: 'Дата рождения',
    nationality: 'Национальность',
    choose_your_document: 'Выберите свой документ',
    choose_document_description_1: 'Выберите документ, который хотите использовать при проверке.',
    choose_document_description_2: 'Мы принимаем только действительные документы государственного образца.',
    choose_document_description_3: 'Любые другие документы, которых нет в списке, будут отклонены.',
    document_number: 'Номер документа',
    country_of_issue: 'Страна выпуска',
    document_issue_date: 'Дата выпуска документа',
    document_expiry_date: 'Срок действия документа',
    files_requirements: 'Требования к файлам',
    format: '{format} или {or} формат',
    maximum_file_size: 'Максимальный размер файла {size}',
    minimum_picture_size: 'Минимальный размер картинки {size} пикселей',
    not_accepted_documents: 'Не принимаемые документы',
    expired: 'Просрочены',
    edited: 'Отредактированы',
    black_and_white: 'Черно-белые',
    broken_or_damaged: 'Сломанные или поврежденные',
    illegible_blurred_or_reflective: 'Неразборчивые, размытые или отражающие',
    cut_off_or_overcropped: 'Обрезанные или перекроенные',
    upload_front_page: 'Загрузите главную страницу',
    upload_back_page: 'Загрузите обратную страницу',
    selfie_description: 'Пожалуйста, загрузите свою фотографию держа удостоверение личности и лист бумаги с Вашим именем, текстом «BitSkins.com» и сегодняшней датой.',
    example_of_correctly_taken_photo: 'Пример правильно сделанной фотографии',
    with_sunglasses_cap_or_mask: 'В солнцезащитных очках, кепке или маске',
    information_covered_by_finger: 'Информация на Вашем документе закрыта пальцами',
    face_covered_by_document: 'Ваше лицо закрыто Вашим документом',
    out_of_focus: 'Ваше лицо или Ваш документ не в фокусе',
    upload_selfie: 'Загрузите селфи',
    send_level_1_kyc_request: 'Отправьте запрос на верификацию KYC 1 уровня',
    address_line_1: 'Адресная строка 1',
    address_line_2_optional: 'Адресная строка 2 (необязательно)',
    state_or_province: 'Штат или Область',
    proof_of_residency_description: 'Пожалуйста, загрузите документ, подтверждающий Ваш текущий адрес проживания, который Вы указали на предыдущем шаге. Убедитесь, что Ваше полное имя видно в документе.',
    upload_document: 'Загрузите документ',
    accepted_documents: 'Принимаемые документы',
    utility_bills: 'Счета за коммунальные услуги',
    bank_statements: 'Банковские выписки',
    tax_returns: 'Налоговые декларации',
    government_letters: 'Правительственные письма',
    other_document_residential: 'Другие документы, подтверждающие Ваш текущий адрес проживания',
    send_level_2_kyc_request: 'Отправьте запрос верификации KYC 2 уровня',
    submit: 'Отправить',
    submit_correct: 'Предоставьте правильную информацию',
    next: 'Далее',
    send_to_verify: 'Отправить на проверку',
    document_verification: 'Проверка документов',
    level: 'Уровень KYC',
    please_reupload_following_photos: 'Пожалуйста, повторно загрузите следующие фотографии',
    please_reupload: 'Пожалуйста, повторно загрузите',
    we_need_additional_information: 'Нам нужна дополнительная информация',
    file_format_not_supported: 'Этот формат файла не поддерживается.',
    the_file_is_too_big: 'Файл {file_name} слишком большой ({file_size}),<br> максимально {size_limit}.',
    field: {
      document_image_a: 'Первая страница Вашего документа',
      document_image_b: 'Обратная страница Вашего документа',
      user_image: 'Ваш селфи',
      address_image: 'Подтверждение места жительства',
      additional_selfie: 'Дополнительное селфи',
    },
    back_to_bitskins: 'Вернуться к BitSkins',
    withdrawals: 'Вывод',
    get_to_the_next_level: 'Перейдите на следующий уровень, чтобы избавиться<br> от ограничений и получить доступ<br> к новым способам оплаты.',
    after_the_first_page_is_validated: 'После того как первая фотография будет подтверждена, Вы сможете загрузить вторую страницу.',
    accepted: 'Принято',
  },
  camera: {
    cancel: 'Отменено',
    check_permissions: 'Проверьте разрешения',
    take_a_new_photo: 'Сделать новую фотографию',
    take_a_photo: 'Сделать фотографию',
    use_camera: 'Использовать камеру',
    use_photo: 'Использовать фото',
    we_will_need_access_to_your_camera: 'Для продолжения нам понадобится доступ к Вашей камере.',
    please_follow_these_steps: 'Пожалуйста, выполните следующие действия',
    select_the_camera_icon: 'Выберите в адресной строке значок <strong>камеры</strong>',
    select_always_allow_access: 'Выберите <strong>Всегда разрешать доступ к камере</strong>',
    select_done: 'Выберите <strong>Готово</strong>',
  },
  review: {
    leave_a_review: 'Оставить отзыв',
    our_reviews: 'Наши отзывы',
    if_youre_happy: 'Если <span class="color-primary">Вы довольны</span> нашим сервисом, ',
    we_would_appreciate: 'мы будем признательны, если Вы оставите <span class="color-primary">отзыв на Trustpilot</span>, поделившись своим опытом, чтобы помочь нам. Спасибо!',
    if_youre_happy_we_would_appreciate: 'Если <span class="color-primary">Вы не довольны</span> нашим сервисом, мы будем признательны, если Вы оставите <span class="color-primary">отзыв на Trustpilot</span>, поделившись своим опытом, чтобы помочь нам. Спасибо!',
  },
  support: {
    center: 'Центр поддержки',
    tickets_list: 'Список заявок',
    create_ticket: 'Создать заявку',
    submit_ticket: 'Отправить заявку',
    close_ticket: 'Закрыть заявку',
    submit_disclaimer: 'Чтобы ускорить нашу работу и получить ответ как можно быстрее, убедись, что Вы не открываете несколько заявок, касающихся одной и той же проблемы. Среднее время ответа составляет <strong>несколько часов</strong>. Вы можете связаться с нами на <strong>английском, польском и шведском языках</strong>. Благодарим Вас за сотрудничество.',
    enter_your_message: 'Введите своё сообщение',
    new_ticket: 'Новая заявка',
    your_ticket: 'Ваша заявка',
    bitskins_team: 'Команда BitSkins',
    ticket_has_been_closed_by: 'Заявка была<span>закрыта</span>  <span>{by}</span>.',
    ticket_has_been_closed: 'Заявка была <span>закрыта</span>',
    conversation_history: 'История беседы:',
    your_reply: 'Ваш ответ...',
    last_reply_by: 'Последний ответ в',
    send: 'Отправить',
    ticket: 'Заявка',
    title: 'Заголовок',
    category: {
      payments: 'Платежи',
      payment_crypto_deposit: 'Пополнение криптовалютой',
      payment_crypto_withdraw: 'Вывод криптовалюты',
      payment_standard_deposit: 'Стандартный метод пополнения счета',
      payment_standard_withdraw: 'Стандартный метод вывода средств',
      market: 'Рынок',
      market_item_issue: 'Проблема с предметом',
      market_buy_orders: 'Заказ на покупку',
      market_bulk_buy: 'Купить оптом',
      market_missing_screenshot: 'Скриншот отсутствует',
      market_missing_float: 'Степень износа отсутствует',
      market_wrong_price: 'Неправильная цена в Steam',
      market_other: 'Другое',
      trading: 'Обмены',
      trading_deposit: 'Депозит предмета',
      trading_withdraw: 'Вывод предмета',
      account: 'Счет',
      account_2fa: 'Проблема 2FA',
      account_email: 'Проблема с электронной почтой',
      account_kyc: 'KYC',
      account_affiliate: 'Партнерская программа',
      account_restrictions: 'Ограничения',
      account_other: 'Другое',
      other: 'Другое',
      bug_report: 'Сообщение об ошибке',
      api: 'API',
      suggestions: 'Предложения',
      business_inquiry: 'Деловой запрос',
      general_inquiry: 'Общий запрос',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'Сумма',
      crypto: 'Криптовалюта',
      disclaimer_visa_1: 'Имейте в виду, что это нормально, что может пройти до 5 рабочих дней, прежде чем деньги поступят на Ваш банковский счет.',
      disclaimer_visa_2: 'Пожалуйста, убедитесь, что Вы пытаетесь вывести средства именно на карты Visa, а не Mastercard. В настоящее время мы не поддерживаем снятие средств с Mastercard.',
      card_digits: '4 последние цифры Вашей карты',
      binance_id: 'Ваш Binance ID',
      wallet_address: 'Адрес кошелька',
      provider: 'Провайдер',
      transaction_id: 'ID транзакции',
      type: 'Тип',
      method: 'Метод',
      item_link: 'Ссылка на предмет',
      bot_received_item: 'Ссылка на профиль бота в Steam, который получил Ваши предметы.',
      trade_offer_id: 'ID предложения на обмен',
      can_be_found_here: 'можно найти здесь',
      email: 'Введите электронную почту',
    },
    delete_link: 'Удалить ссылку',
    add_link: 'Добавить ссылку',
  },
  service: {
    market: {
      buy: 'Купить',
      sell: 'Продать',
      fee: 'Комиссия за продажу',
      buy_order: 'Заказ на покупку',
      bargain: 'Торговаться',
      instant_sell: 'Мгновенная продажа',
      bump: 'Продвигать',
      bump_package: 'Пакет продвижений',
    },
    deposit: {
      gift_code: 'Подарочный код',
      bitcoin: 'Пополнение BTC',
      litecoin: ' Пополнение LTC',
      ethereum: 'Пополнение ETH',
      unlimint: 'Пополнение счета с помощью банковской карты',
      binance_pay: 'Пополнение счета с помощью Binance Pay',
      binancepay: 'Пополнение счета с помощью Binance Pay',
      available_coupons: 'Доступные купоны:',
      redeem_coupon: 'Активировать купон',
      enter_coupon_code: 'Введите код купона',
      open_binance_website: 'Открой сайт Binance',
      list_of_active_transactions: 'Список активных транзакций:',
      transaction_needs_at_least_x_confirmations: 'Транзакция требует не менее {x} подтверждений, прежде чем средства появятся на Вашем счету.',
      billing_information: '<span class="text-cp">Платежная</span> информация',
      coupon: {
        coupon: 'Купон',
        make_a_gift: 'Сделайте себе или кому-то другому <span class="text-cp">подарок</span>.',
        bitskins_coupons_are_a_good_alternative: 'Купоны BitSkins - это хорошая альтернатива стандартным способам оплаты и отличная идея для подарка. Вы можете приобрести их у наших партнёров, которые предлагают множество способов оплаты.',
        dont_wait: '<span class="text-cp">Не ждите и пополните свой баланс</span> с помощью купона BitSkins или сделай кому-нибудь<br> <span class="text-cp">оригинальный подарок</span> (все мы знаем кого-то с пустым инвентарём).',
        kinguin: 'Kinguin (новые сниженные комиссии)',
      },
      crypto: {
        get_wallet_address: 'Получить адрес кошелька',
        your_wallet_address: 'Адрес Вашего кошелька',
        this_address_is_only_for_x: 'Этот адрес предназначен только для {x} пополнений. Не отправляйте на этот адрес никаких других криптовалют.',
        this_address_will_not_expire: 'Этот адрес не имеет срока действия. Вы можете использовать его в любое время.',
        choose_alternative_address: 'Выберите альтернативный адрес',
        the_acutal_amount_you_will_be_credited: 'Фактическая сумма, которую Вы получите на счет, зависит от {x} цены на момент получения Вашего платежа.',
        only_l1_transactions: '<span class="text-cy">Поддерживаются только L1-транзакции. Не используйте внутренние транзакции и смарт-контракты!</span>.',
      },
      zen: {
        zen: 'Пополнение с помощью ZEN',
        deposit_started: 'Пополнение ZEN запущено,',
        open_the_zen_deposit_page: 'откройте страницу пополнения счета ZEN',
        processing_fee: 'ZEN добавит к транзакции комиссию за обработку, которая зависит от выбранного способа оплаты. Окончательная сумма транзакции будет видна на их сайте.',
        each_transaction_is_reviewed: 'Каждая транзакция проверяется ZEN Pay и может занимать <span class="text-cp">от минуты до нескольких часов</span>.',
      },
      the_minimum_deposit_amount_is: 'Минимальная сумма пополнения составляет {amount}.',
      the_maximum_deposit_amount_is: 'Максимальная сумма пополнения составляет {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">Мы предлагаем выплаты только на binance.com (binance.us не поддерживается).</span>.',
      bitcoin: 'Вывести BTC',
      litecoin: 'Вывести LTC',
      ethereum: 'Вывести ETH',
      unlimint: 'Вывод средств на карту VISA',
      tipalti: {
        tipalti: 'Вывод средств с помощью Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti позволяет Вам выводить средства на свой банковский счет и счет PayPal.',
        you_dont_have_a_tipalti_acount: 'У Вас нет аккаунта в Tipalti?',
        you_have_to_create_an_account: 'Чтобы вывести свои средства через Tipalti, Вам нужно создать аккаунт на их сайте.<br>Вы можете сделать это, нажав на кнопку ниже.',
        create_tipalti_account: 'Создать учетную запись Tipalti',
        check_your_email: 'Пожалуйста, проверьте <span class="text-cp">свой почтовый ящик</span> и перейдите по ссылке подтверждения, чтобы завершить процесс создания учётной записи. Если Вы не можете найти письмо в своем почтовом ящике, проверьте папку "Спам".',
        payment_method: 'Способ оплаты',
        tipalti_panel: 'Панель Tipalti',
        tipalti_payouts_incur_a_fee: 'При выплатах Tipalti взимается комиссия, которая может достигать $26. Размер комиссии зависит от выбранного способа оплаты. Ниже приведена таблица с комиссией для каждого способа оплаты.',
        fee_per_payment: 'Комиссия за один платеж',
        rejection_fee: 'Комиссия за отказ',
        echeck_local: 'eCheck (Local)',
        paypal_non_us: 'PayPal (не резидент США)',
        paypal_us: 'PayPal (резидент США)',
        wire_transfer_non_us_non_usd: 'Банковский перевод (не резидент США платит не в долларах США)',
        wire_transfer_non_us_usd: 'Банковский перевод (не резидент США платит в долларах США)',
        wire_transfer_us: 'Банковский перевод (резидент США)',
        up_to_21_usd: 'до $21.00',
        up_to_2_usd: 'до $2.00',
      },
      payoneer: 'Вывод средств с помощью Payoneer',
      binance_pay: 'Вывод средств с помощью Binance Pay',
      binancepay: 'Вывод средств с помощью Binance Pay',
      p2p: 'Трансфер P2P',
      payouts_are_performed_on_a_rolling_basis: 'Выплаты производятся по мере поступления в течение 5 минут после запроса.',
      your_payout_will_be_processed_at_the_current_rate: 'Ваша выплата будет обработана по текущему курсу.',
      please_verify_the_wallet_address: 'Пожалуйста, подтвердите адрес кошелька. Мы не можем вернуть средства в случае неправильного вывода средств.',
      the_data_controller: 'Ответственным за обработку данных и контрагентом Unlimint в отношении обрабатываемых ею платежей является компания Bitskins Sp. z o.o. с юридическим адресом 40-246 Katowice, Porcelanowa str. 23, Poland, зарегистрированная под номером: 0000810143 - более подробную информацию можно найти в Политике конфиденциальности и Условиях использования.',
      visa_withdrawals_are_processed_instantly: 'Вывод средств на карту VISA обрабатывается мгновенно. Однако в некоторых случаях может пройти до нескольких дней, прежде чем деньги появятся на Вашем банковском счете.',
      card_info: 'Информация о карте',
      ccv: 'CCV',
      add_new_deposit_needed: 'Добавить новый (нужен депозит)',
      you_can_have_max_3_bank_cards: 'К Вашему счету может быть привязано не более трех банковских карт.',
      your_cards_amount: '<span class="text-cp">Ваши</span> карты ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'Минимальная сумма вывода средств составляет {x}.',
      the_maximum_withdraw_amount_is_x: 'Максимальная сумма вывода средств составляет {x}.',
      enter_amount: 'Введите сумму',
      go_to_card_deposit: 'Перейдите к пополнению счета карты',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Чтобы иметь возможность вывести средства, Вам необходимо сначала подтвердить свою карту. Вы можете сделать это, пополнив счет на $1.',
      deposited_funds_are_non_withdrawable: 'Обратите внимание, что внесенные средства не подлежат выводу и могут быть использованы только для покупок.',
      we_do_not_support_mastercard_withdrawals: 'Мы не поддерживаем вывод средств на карты MasterCard и на карты, выпущенные в следующих странах: Босния и Герцеговина, Канада, Египет, Япония, Камбоджа, Корея (Республика), Косово, Северная Македония, Соединенные Штаты Америки, Аргентина.',
      your_card_is_valid_until: 'Ваша карта действительна до 16.02.2023, 15:35 (UTC). По истечении этого времени Вам придется повторно подтвердить свою карту, пополнив счёт на $5.',
      card_verification_required: '<span class="text-cp">Верификация карты</span> обязательна',
      card: 'Карта',
      add_new_card: '<span class="text-cp">Добавь новую</span> карту',
      how_to_find_my_binance_id: 'Как найти свой идентификатор пользователя (BUID) на Binance?',
      how_to_find_my_pay_id: 'Как найти мой Pay ID на Binance?',
      how_to_find_my_email: 'Как найти мою электронную почту на Binance?',
      binance_id: 'Binance ID',
      receiver_type: 'Тип получателя',
      i_do_not_have_a_binance_account: 'У меня нет счета на Binance',
      i_have_a_binance_account: 'У меня есть счет на Binance',
      binance_account: '<span class="text-cp">Binance</span>счет',
      the_fee_is_already_included_in_the_current_x_rate: 'Комиссия в размере {fee}% уже включена в текущую ставку {x}.',
    },
    wallet: {
      transfer: 'Перевод средств',
      refund: 'Возврат денежных средств',
      available_payment_methods: 'Доступные способы оплаты',
      bank_cards: 'Банковские карты',
      kyc_required_for_this_payment_method: 'Вы не можете использовать этот способ оплаты, поскольку не прошли процедуру KYC. Вы можете начать процесс проверки прямо сейчас.',
      kyc_limit_exceeded: 'Вы не можете использовать этот способ оплаты, поскольку превысили лимит транзакций для вашего уровня KYC. Вы можете начать процесс проверки прямо сейчас, чтобы снять ограничения.',
      no_limit: 'Без ограничений',
      limits_info: 'В Bitskins <strong>каждая транзакция имеет свой таймер и лимит, которые обнуляются через год после совершения транзакции</strong>. Максимальные суммы, которые Вы можете внести или вывести, показаны на графиках. Вы можете увеличить лимиты или полностью избавиться от них, пройдя процедуру KYC.',
      crypto_deposits: 'Криптовалютные депозиты',
      crypto_withdrawals: 'Вывод средств в криптовалюту',
      standard_deposits: 'Стандартные депозиты',
      standard_withdrawals: 'Стандартный вывод средств',
      coupons_are_excluded_from_the_limit: '* купоны не включены в лимит',
      x_type_does_not_incur_any_fees: '{x} {type} не взимается никаких комиссий',
      incur_fees_of: 'взимать плату в размере',
      plus: ' плюс ',
      the_minimum_type_amount_is: '<span class="color-primary">минимальная {type}</span>сумма составляет',
      the_maximum_type_amount_is: '<span class="color-primary">максимальная {type}</span>сумма составляет',
      due_to_unstable_crypto_network: 'Из-за нестабильной криптосети могут возникнуть некоторые задержки.',
      binance_temporarily_disabled: 'Вывод средств на Binance отключен до понедельника (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'Баланс',
      sell: 'Продано',
      buy: 'Куплено',
    },
    report_status: {
      empty: 'Пусто',
      pending: 'В ожидании',
      done: 'Готово',
    },
    autobump_period: {
      hour_1: '1 час',
      hour_3: '3 часа',
      hour_6: '6 часов',
      hour_12: '12 часов',
      hour_24: '24 часа',
      hour_48: '48 часов',
    },
    autobump_status: {
      not_enough_bumps: 'Недостаточное количество продвижений',
      finished: 'Готово',
      cancelled: 'Отменено',
      pending: 'В ожидании',
      active: 'Активно',
    },
    inventory_status: {
      issue: 'Проблема',
      not_available: 'Недоступно',
      deleted: 'Исключен из списка',
      withdrawn: 'Выведено',
      delisted: 'Исключен из списка',
      ready: 'Готово',
      listed: 'Размещено',
      listed_private: 'Размещено как частное',
      sold: 'Продано',
      withdraw_queue: 'Очередь на вывод',
      withdraw_pending: 'Отложенный вывод',
      instant_sell: 'Мгновенная продажа',
    },
    service: {
      market: {
        buy: 'Купить',
        sell: 'Продать',
        fee: 'Комиссия за продажу',
        buy_order: 'Заказ на покупку',
        bargain: 'Торги',
        instant_sell: 'Мгновенная продажа',
        bump: 'Продвигать',
        bump_package: 'Пакет продвижений',
      },
      deposit: {
        bitcoin: 'Пополнение BTC',
        litecoin: 'Пополнение LTC',
        ethereum: 'Пополнение ETH',
        unlimint: 'Пополнение с помощью банковской карты',
        zen: 'Пополнение с помощью ZEN',
        gift_code: 'Подарочный код',
        binancepay: 'Пополнение счета с помощью Binance Pay',
      },
      withdraw: {
        bitcoin: 'Вывести BTC',
        litecoin: 'Вывести LTC',
        ethereum: 'Вывести ETH',
        unlimint: 'Вывод средств на карту VISA',
        tipalti: 'Вывод средств с помощью Tipalti',
        payoneer: 'Вывод средств с помощью Payoneer',
        binancepay: 'Вывод средств с помощью Binance Pay',
        p2p: 'Трансфер P2P',
      },
      wallet: {
        transfer: 'Перевод средств',
        refund: 'Возврат денежных средств',
      },
      marketing: {
        coupon: 'Купон',
        referral: 'Реферал',
        affiliate: 'Партнерская программа',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins предлагает универсальную платформу для покупки и продажи предметов CS2, DOTA2, TF2, RUST. Изучите огромный выбор винтовок, ножей, перчаток и многого другого. Присоединяйтесь прямо сейчас, чтобы торговать с легкостью!',
    home_title: 'BitSkins.com - Покупка и продажа скинов CS2. Быстрая, лёгкая и безопасная торговля',
    home_description: 'BitSkins предлагает универсальную платформу для покупки и продажи предметов CS2, DOTA2, TF2, RUST. Изучите огромный выбор винтовок, ножей, перчаток и многого другого. Присоединяйтесь прямо сейчас, чтобы торговать с легкостью!',
    support_title: 'Служба поддержки BitSkins: получите помощь о том, как правильно торговать в CS2',
    support_description: 'Нужна помощь с торговлей в CS2? Посетите страницу поддержки BitSkins для получения оперативной помощи. Наша команда готова ответить на Ваши вопросы, решить проблемы и дать рекомендации.',
    item_title: '{item} - {game} Скины | Найдите и обменяйте желаемые {game} предметы',
    item_description_csgo: 'Находите и обменивайте желаемые скины из CS2 на BitSkins. Изучите нашу обширную коллекцию винтовок, ножей, перчаток и многого другого. Покупайте, продавайте или выводите средства мгновенно. Начните просмотр прямо сейчас!',
    item_description_cs2: 'Находите и обменивайте желаемые скины из CS2 на BitSkins. Изучите нашу обширную коллекцию винтовок, ножей, перчаток и многого другого. Покупайте, продавайте или выводите средства мгновенно. Начните просмотр прямо сейчас!',
    item_description_dota2: 'Находите и обменивайте желаемые скины из DOTA2 на BitSkins. Изучите нашу обширную коллекцию вардов, музыки, наборов и многого другого. Покупайте, продавайте или выводите средства мгновенно. Начните просмотр прямо сейчас!',
    item_description_tf2: 'Находите и обменивайте желаемые предметы из TF2 на BitSkins. Изучите нашу обширную коллекцию скинов, насмешек, ящиков и многого другого. Покупайте, продавайте или выводите средства мгновенно. Начните просмотр прямо сейчас!',
    item_description_rust: 'Находите и обменивайте желаемые предметы из RUST на BitSkins. Изучите нашу обширную коллекцию одежды, оружия, ресурсов и многого другого. Покупайте, продавайте или выводите средства мгновенно. Начните просмотр прямо сейчас!',
    market_title: 'Магазин BitSkins: Находите и обменивайтесь {game} предметами с лёгкостью',
    market_description_csgo: 'Заходите в магазин BitSkins, чтобы легко исследовать и торговать широким спектром предметов из CS2. Откройте для себя лучшие предложения на скины, ключи, капсулы и многое другое. Покупайте, продавайте или выводите средства мгновенно.',
    market_description_cs2: 'Заходите в магазин BitSkins, чтобы легко исследовать и торговать широким спектром предметов из CS2. Откройте для себя лучшие предложения на скины, ключи, капсулы и многое другое. Покупайте, продавайте или выводите средства мгновенно.',
    market_description_dota2: 'Заходите в магазин BitSkins , чтобы легко исследовать и торговать широким спектром предметов из DOTA2. Откройте для себя лучшие предложения на варды, музыку, наборы и многое другое. Покупайте, продавайте или выводите средства мгновенно.',
    market_description_tf2: 'Заходите в магазин BitSkins, чтобы легко исследовать и торговать широким спектром предметов из TF2. Откройте для себя лучшие предложения по скинам, насмешкам, ящикам и многому другому. Покупайте, продавайте или выводите средства мгновенно.',
    market_description_rust: 'Заходите в магазин BitSkins, чтобы легко исследовать и торговать широким ассортиментом предметов из RUST. Откройте для себя лучшие предложения на одежду, оружие, ресурсы и многое другое. Покупайте, продавайте или выводите средства мгновенно.',
    market_item_title: 'Магазин BitSkins: {skin} : {game} Магазин',
    store_title: 'Магазин пользователя BitSkins: {alias} - {game} Витрина предметов',
    store_description: 'Магазин пользователя BitSkins, где можно демонстрировать и продавать свои товары. Устанавливайте цены, общайтесь с покупателями и обеспечивайте свое присутствие в торговом сообществе.',
    login_title: 'Вход в BitSkins: Безопасный доступ к вашему торговому счету в CS2',
    login_description: 'Безопасно входите в свою учетную запись BitSkins. Получите доступ к своему инвентарю CS2, управляйте предметами, совершайте транзакции и наслаждайтесь беспроблемной торговлей.',
    steam_login_title: 'Вход с помощью Steam',
    profile_title: 'Настройки Вашего аккаунта',
    wallet_title: 'Ваши средства BitSkins',
    affiliate_title: 'Партнерская панель BitSkins: зарабатывайте вознаграждения за рефералов',
    affiliate_description: 'Присоединяйтесь к партнерской программе BitSkins и получайте вознаграждения, привлекая любителей скинов. Воспользуйтесь выгодной партнерской программой, отслеживайте своих рефералов и максимизируйте свой заработок.',
    statistics_title: 'Статистика продаж BitSkins: узнайте рыночные тенденции и идеи',
    statistics_description: 'Изучите исчерпывающую статистику BitSkins, чтобы получить ценную информацию о торговых тенденциях CS2. Анализируйте рыночные данные, популярность предметов и многое другое, чтобы оптимизировать свои торговые стратегии.',
    sales_fees_title: 'Комиссии с продаж BitSkins: прозрачные цены для ваших CS2 продаж ',
    sales_fees_description: 'Получите четкое представление о структуре комиссии за продажу в BitSkins. Наши прозрачные комиссии обеспечивают честность и простоту ваших СS2 продаж. Узнать больше.',
    checkout_title: 'Корзина BitSkins: удобное оформление заказа для CS2 предметов',
    checkout_description: 'Упростите свой торговый опыт в CS2 с помощью корзины BitSkins. Легко управляйте своими предметами, просматривайте свой заказ и переходите к безопасному оформлению. Наслаждайтесь беспроблемным процессом торговли уже сегодня!',
    steam_inventory_title: 'Мой {game} инвентарь в Steam',
    bs_inventory_title: 'Мой {game} инвентарь BitSkins',
    selling_inventory_title: 'Мои предметы из списка {game}',
    buy_order_create_title: 'Создание заказов на покупку для {game}',
    buy_order_active_title: 'Активные заказа на покупку {game}',
    buy_order_title: 'Заказы на покупку {game}',
    trades_active_title: 'Активные обмены',
    trades_history_title: 'История обмена',
    transactions_title: 'Транзакции',
    favorites_title: 'Избранные предметы',
    kyc_title: 'Форма заявления "Знай своего клиента" (KYC)',
    tos_title: 'Условия использования BitSkins: Руководство для безопасной и надежной торговли',
    tos_description: 'Ознакомьтесь с нашими Условиями использования для безопасной и надёжной торговли. Ознакомьтесь с нашей политикой и обязательствами. Торгуйте безопасно в BitSkins.',
    privacy_policy_title: 'Политика конфиденциальности BitSkins: Безопасность Вашей личной информации',
    privacy_policy_description: 'Прочтите Политику конфиденциальности BitSkins, чтобы узнать, как мы защищаем и обрабатываем Вашу личную информацию. Доверие и прозрачность лежат в основе наших обязательств.',
    cookie_policy_title: 'Политика использования файлов cookie компании BitSkins: Ваша конфиденциальность важна для нас',
    cookie_policy_description: 'В BitSkins мы ценим Вашу конфиденциальность. Прочтите нашу Политику использования файлов cookie, чтобы понять, как мы используем файлы cookie и аналогичные технологии. Ваше доверие и безопасность данных — наши главные приоритеты.',
    docs_v1_title: 'BitSkins API V1: Версия Legacy API',
    docs_v1_description: 'Интегрируйте BitSkins API V1 для беспрепятственной торговли. Получите доступ к документации для оптимизации ваших торговых возможностей. Обновитесь до последней версии, чтобы получить доступ к новым функциям.',
    docs_v2_title: 'BitSkins API V2: Самая новая версия API',
    docs_v2_description: 'Разблокируйте новые возможности с помощью BitSkins API V2. Повысьте свои торговые стратегии и эффективность. Ознакомьтесь с нашей подробной документацией прямо сейчас!',
    docs_migration_title: 'Миграция API BitSkins: беспроблемный переход на новый API',
    docs_migration_description: 'Беспроблемно перейдите на новый API BitSkins с помощью нашего подробного руководства. Изучите обновлённые функции и процессы интеграции для улучшения торговых возможностей.',
  },
  alt: {
    envelope: 'Конверт',
    app_store: 'App Store',
    google_store: 'Google Store',
  },
  time: {
    seconds: 'секунд',
  },
  calendar: {
    week: 'Неделя',
    month: 'Месяц',
    lifetime: 'Пожизненный',
  },
  docs: {
    docs: 'Документы',
    api: 'API',
    api_v1: 'API V1 (шлюз)',
    api_v2: 'API V2',
    api_migration_guide: 'Руководство по миграции API',
    request_parameters: 'Параметры запроса',
    sample_request: 'Образец запроса',
    sample_response: 'Образец ответа',
    request_schema: 'Схема запроса',
    enums: 'ПЕРЕЧИСЛЕНИЯ',
  },
  wallet: {
    deposit_type: '{source} {type}',
    coupon_redeemed: 'Вы активировали купон на {amount}',
    balance_changed: 'Баланс был обновлен',
    transfer_p2p_confirm: 'Подтвердите перевод средств на сайт p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Вам необходимо подтвердить перевод',
    transfer_p2p_success: 'Ваши средства были переведены на сайт p2p.bitskins.com',
    transfer_funds: 'Перевод средств',
    deposit_started: 'Депозит открыт',
    card_removed: 'Карточка удалена',
    confirm_card_remove: 'Вы уверены, что хотите удалить эту карту?',
    delete_card: 'Удалить карту',
    deposit: 'пополнение',
    withdraw: 'вывести',
    security_code: 'Код безопасности',
    security_code_ccv: 'Код безопасности',
    card_number: 'Номер карты',
    full_name: 'Полное имя',
    month_expired: 'Месяц истек (ММ/ГГГГ)',
    addr_line_1: 'Адрес для выставления счета (строка 1)',
    addr_line_2: 'Адрес для выставления счета (строка 2)',
    zip: 'почтовый индекс',
    city: 'Город',
    country: 'Страна',
    withdraw_only_to_visa: 'Вы можете выводить средства только на карту Visa',
    card_country_is_restricted: 'К сожалению, мы не осуществляем вывод средств на карты, выпущенные в {country}.',
  },
  twofa: {
    required: 'Требуется двухфакторная аутентификация',
    required_for_this_payment_method: 'Вы не можете использовать этот способ оплаты, потому что не настроили двухфакторную аутентификацию.',
    you_can_start_now: 'Вы можете начать процесс установки прямо сейчас.',
    setup: 'Настройка 2FA',
    why_we_require: 'Нажмите, чтобы прочитать - Почему мы требуем 2FA для вывода средств?',
  },
  password_strong: {
    minimum: 'Пароль должен иметь длину не менее {value} символов',
    maximum: 'Длина пароля должна составлять не более {value} символов',
    lowercase: 'Пароль должен содержать хотя бы 1 строчную букву',
    uppercase: 'Пароль должен содержать хотя бы 1 прописную букву',
    numeric: 'Пароль должен содержать хотя бы 1 цифру',
    special: 'Пароль должен содержать как минимум 1 специальный символ',
  },
  help_center: {
    help_center: 'Служба поддержки',
    hello: 'Здравствуйте. Чем я могу Вам помочь?',
    create_ticket: 'создать заявку',
    contact_us: 'Связаться с нами',
    guide: 'Руководство',
    top_articles: 'Популярные статьи',
    didnt_find: 'Не нашли то, что Вам нужно?',
    article: 'Статьи',
    general: 'Основное',
    fees: 'Комиссии',
    buying_selling: 'Покупка & Продажа',
    deposit_withdrawal: 'Пополнения & Выводы',
    refunds: 'Возвраты',
    user_account: 'Учетная запись пользователя',
    affiliate: 'Партнерская программа',
    partnership: 'Сотрудничество',
    scam: 'Подозрение на мошенничество',
    was_helpful: 'Была ли эта статья полезна?',
    found_helpful: '{yes} из {max} нашли это полезным',
    faq: 'Часто задаваемые вопросы',
  },
};
